    var WM_IS_SAFARI_DESKTOP = (() => {
      const ua = navigator.userAgent || '';
      const isSafari = /Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR/.test(ua);
      const isMobile = /Mobile|iP(hone|ad|od)/.test(ua) || (navigator.maxTouchPoints > 1 && navigator.platform === 'MacIntel');
      return isSafari && !isMobile;
    })();
    
    
    let WM_MEDIA_UNLOCKED = false;
    let WM_AUDIO_CTX = null;
    let WM_PLAYER = null;
    let WM_OWNER = { slide: null };
    let WM_SHUFFLE_BOOTING = false;
    let WM_PENDING_AUTOBOOT = false;
    let WM_OVERLAY_UNLOCKING = false;

    function setButtonToPlay(btn){
      if (!btn) return;
      btn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="#ffffff" d="M8 5v14l11-7z"></path>
        </svg>
      `;
    }

    function setButtonToPause(btn){
      if (!btn) return;
      btn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="#ffffff" d="M6 5h4v14H6zM14 5h4v14h-4z"></path>
        </svg>
      `;
    }
    
    
    let WM_WARM_VIDEO = null;
    function wmEnsureWarmVideo() {
      if (WM_WARM_VIDEO) return;
      const v = document.createElement('video');
      v.playsInline = true; v.muted = true; v.loop = true; v.autoplay = true;
      v.style.display = 'none';
      v.src = 'data:video/mp4;base64,AAAAIGZ0eXBtcDQyAAAAAG1wNDFtcDQy';
      document.body.appendChild(v);
      WM_WARM_VIDEO = v;
    }
    function wmSyncOwnerButtonState(isPlaying) {
      const slide = WM_OWNER.slide;
      if (!slide) return;

      const productSlide = slide.closest('.product-slide');
      if (productSlide) {
        productSlide.querySelectorAll('.play-pause-button').forEach(btn => setButtonToPlay(btn));
      }

      const btn = slide.querySelector('.play-pause-button');
      if (!btn) return;
      if (isPlaying) {
        setButtonToPause(btn);
      } else {
        setButtonToPlay(btn);
      }
    }

    function wmCreateSingletonPlayer() {
      if (WM_PLAYER) return WM_PLAYER;
      WM_PLAYER = document.createElement('audio');
      WM_PLAYER.id = 'WM_PLAYER';
      WM_PLAYER.playsInline = true;
      WM_PLAYER.muted = true;
      WM_PLAYER.preload = 'none';
      WM_PLAYER.style.display = 'none';
      document.body.appendChild(WM_PLAYER);
    
      WM_PLAYER.addEventListener('timeupdate', () => {
        const slide = WM_OWNER.slide;
        if (!slide) return;
        const filled = slide.querySelector('.progress-filled');
        const dot = slide.querySelector('.progress-dot');
        const d = WM_PLAYER.duration || 0;
        if (d > 0) {
          const pct = (WM_PLAYER.currentTime / d) * 100;
          if (filled) filled.style.width = `${pct}%`;
          if (dot) dot.style.left = `${pct}%`;
        }
      });
      WM_PLAYER.addEventListener('ended', () => {
        const slide = WM_OWNER.slide;
        if (!slide) return;
        wmSyncOwnerButtonState(false);
        const carousel = slide.closest('.audio-player-carousel');
        if (carousel?.swiperInstance) {
          const swiper = carousel.swiperInstance;
          const slides = carousel.querySelectorAll('.audio-player-slide');
          const idx = Array.from(slides).indexOf(slide);
          if (idx < slides.length - 1) swiper.slideTo(idx + 1);
        }
      });
      WM_PLAYER.addEventListener('play', () => {
        wmSyncOwnerButtonState(true);
      });
      WM_PLAYER.addEventListener('pause', () => {
        wmSyncOwnerButtonState(false);
      });
      return WM_PLAYER;
    }
    async function wmUnlockAudioOnce() {
      if (WM_MEDIA_UNLOCKED) return;
      WM_MEDIA_UNLOCKED = true;
      try {
        WM_AUDIO_CTX = WM_AUDIO_CTX || new (window.AudioContext || window.webkitAudioContext)();
        if (WM_AUDIO_CTX.state !== 'running') await WM_AUDIO_CTX.resume();
        const osc = WM_AUDIO_CTX.createOscillator();
        const gain = WM_AUDIO_CTX.createGain();
        gain.gain.value = 0.00001;
        osc.connect(gain).connect(WM_AUDIO_CTX.destination);
        osc.start(); osc.stop(WM_AUDIO_CTX.currentTime + 0.03);
      } catch(e){}
      try { wmEnsureWarmVideo(); await WM_WARM_VIDEO.play().catch(()=>{}); } catch(e){}
      const p = wmCreateSingletonPlayer();
      try { await p.play().catch(()=>{}); } catch(e){}
      try { p.pause(); } catch(e){}
      window.dispatchEvent(new Event('audioUnlocked'));
    }
    function wmWhenCanPlay(el) {
      return new Promise(res => {
        if (el.readyState >= 3) return res();
        const done = () => { cleanup(); res(); };
        const cleanup = () => ['canplay','canplaythrough','loadeddata','loadedmetadata'].forEach(ev => el.removeEventListener(ev, done));
        ['canplay','canplaythrough','loadeddata','loadedmetadata'].forEach(ev => el.addEventListener(ev, done, { once:true }));
        setTimeout(()=>{ cleanup(); res(); }, 800);
      });
    }
    async function wmSafePlaySlide(slide, { unmute = true } = {}) {
      const player = wmCreateSingletonPlayer();
      const srcHolder = slide.querySelector('.slide-audio');
      if (!srcHolder) return;
      const nextSrc = (srcHolder.dataset && srcHolder.dataset.src) ? srcHolder.dataset.src : srcHolder.src;
      if (!nextSrc) return;
    
        const isNewSrc = (player.src !== nextSrc);
    
      if (isNewSrc) {
        player.src = nextSrc;
        player.preload = 'auto';
      }
    
      const readyEnough = player.readyState >= 2;
      if (isNewSrc || !readyEnough) {
        await wmWhenCanPlay(player);
      }
    
      await new Promise(r => requestAnimationFrame(r));
    
    
      WM_OWNER.slide = slide;
      try {
        player.muted = true;
        await player.play();
        if (unmute && WM_MEDIA_UNLOCKED) requestAnimationFrame(()=> { player.muted = false; });
        player.dataset.playing = '1';
      } catch (e) {
        if (e && e.name === 'NotAllowedError') {
          const retry = () => { window.removeEventListener('touchstart', retry); wmSafePlaySlide(slide, { unmute }); };
          window.addEventListener('touchstart', retry, { once:true, passive:true });
        }
      }
    }
    function wmPauseSlide(slide) {
      if (!WM_PLAYER) return;
      if (WM_OWNER.slide === slide) {
        try { WM_PLAYER.pause(); } catch {}
        WM_PLAYER.dataset.playing = '0';
      }
    }
    
    function wmEnhanceCoverImage(img, indexOnPage){
      if (!img) return;
    
      if (WM_IS_SAFARI_DESKTOP) {
        try { img.loading = 'eager'; } catch(e){}
        try { img.setAttribute('loading', 'eager'); } catch(e){}
    
        try { img.fetchPriority = 'high'; } catch(e){}
        try { img.setAttribute('fetchpriority', 'high'); } catch(e){}
    
      } else {
        try { img.loading = (indexOnPage < 3 ? 'eager' : 'lazy'); } catch(e){}
        try { img.setAttribute('loading', (indexOnPage < 3 ? 'eager' : 'lazy')); } catch(e){}
        if (indexOnPage < 3) {
          try { img.fetchPriority = 'high'; } catch(e){}
          try { img.setAttribute('fetchpriority', 'high'); } catch(e){}
        }
      }
    
      try { img.decoding = 'async'; } catch(e){}
      try { img.setAttribute('decoding', 'async'); } catch(e){}
    
    }
    
    
    function wmPrefetchSlideNeighbors(carousel, activeIdx){
      const slides = carousel.querySelectorAll('.audio-player-slide');
      [-1, 1].forEach(offset => {
        const s = slides[activeIdx + offset];
        if (!s) return;
        const img = s.querySelector('.audio-cover');
        if (img) { const pre = new Image(); pre.decoding = 'async'; pre.src = img.currentSrc || img.src; }
        const a = s.querySelector('.slide-audio');
        if (a && !a.src && a.dataset?.src) { a.src = a.dataset.src; a.preload = 'metadata'; }
      });
    }
    function wmHydrateSlidesNearViewport(rootEl){
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const slide = entry.target;
          const audio = slide.querySelector('.slide-audio');
          if (audio && !audio.src && audio.dataset?.src) { audio.src = audio.dataset.src; audio.preload = 'metadata'; }
          const next = slide.nextElementSibling;
          if (next) {
            const nimg = next.querySelector('.audio-cover');
            if (nimg) { const pre = new Image(); pre.decoding = 'async'; pre.src = nimg.currentSrc || nimg.src; }
            const na = next.querySelector('.slide-audio');
            if (na && !na.src && na.dataset?.src) { na.src = na.dataset.src; na.preload = 'metadata'; }
          }
          io.unobserve(slide);
        });
      }, { root: rootEl, rootMargin: '900px 0px', threshold: 0.01 });
      document.querySelectorAll('.audio-player-slide').forEach(s => io.observe(s));
    }
    
    function wmSafariLazyImageFix(rootEl){
      if (!WM_IS_SAFARI_DESKTOP || !rootEl) return;
    
      if (!rootEl._wmSafariLazyFixIO) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
    
            const img = entry.target;
    
            try { img.loading = 'eager'; } catch(e){}
            try { img.decoding = 'async'; } catch(e){}
    
            const srcAttr = img.getAttribute('src');
            if (img.dataset?.src && (!srcAttr || srcAttr === '')) {
              img.src = img.dataset.src;
            }
            const srcsetAttr = img.getAttribute('srcset');
            if (img.dataset?.srcset && (!srcsetAttr || srcsetAttr === '')) {
              img.srcset = img.dataset.srcset;
            }
    
            const pic = img.closest('picture');
            if (pic) {
              pic.querySelectorAll('source').forEach(source => {
                const ss = source.getAttribute('srcset');
                if ((!ss || ss === '') && source.dataset?.srcset) {
                  source.setAttribute('srcset', source.dataset.srcset);
                }
              });
            }
    
            setTimeout(() => {
              if (img.naturalWidth === 0) {
                const s = img.currentSrc || img.getAttribute('src') || img.src;
                if (!s) return;
    
                if (img.getAttribute('srcset')) img.removeAttribute('srcset');
    
                img.src = '';
                img.src = s;
              }
            }, 120);
    
            io.unobserve(img);
          });
        }, { root: rootEl, rootMargin: '900px 0px', threshold: 0.01 });
    
        rootEl._wmSafariLazyFixIO = io;
      }
    
      const io = rootEl._wmSafariLazyFixIO;
    
      rootEl.querySelectorAll('img.audio-cover, img[loading="lazy"], picture img').forEach(img => {
        if (img.dataset.wmSafariObserved === '1') return;
        img.dataset.wmSafariObserved = '1';
        io.observe(img);
      });
    }
    
    
    
    
    
    /* ================================
       Section logic
    ================================ */
    document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('error', (e) => {
      console.warn('[WM] JS error:', e.message, e.filename, e.lineno);
    });
    window.addEventListener('unhandledrejection', (e) => {
      console.warn('[WM] Unhandled promise rejection:', e.reason);
    });
    
      /* =========================================================
       WM SPECIAL CARDS (works for shuffle + lazy load)
    ========================================================= */
    const WM_SPECIAL = {
      inserted: new Set(),
      // counts PRODUCT slides rendered (excludes special cards)
      productCount: 0,
    };
    // If Liquid already rendered any special cards on page 1,
    // mark them as inserted so JS won't duplicate them.
    document.querySelectorAll('.wm-special-card[data-wm-special-id]').forEach(el => {
      const id = el.getAttribute('data-wm-special-id');
      if (id) WM_SPECIAL.inserted.add(id);
    });
    
    
    function wmCountProductsInDom(container){
      return Array.from(container.querySelectorAll('.product-slide'))
        .filter(s => !s.classList.contains('wm-special-card') && s.dataset.wmSpecial !== '1')
        .length;
    }
    
    function wmBuildSpecialCardEl(sc){
      const section = document.createElement('section');
    section.className = 'product-slide wm-special-card'
      + (sc.hide_on_desktop ? ' wm-hide-desktop' : '')
      + (sc.card_layout === 'app_popup' ? ' wm-special-card--app-popup' : '');
      section.dataset.wmSpecial = '1';
      section.dataset.wmSpecialId = sc.id;
      section.dataset.wmVisibility = sc.visibility || 'everyone';
      section.dataset.wmCardLayout = sc.card_layout || 'standard';
    
      // match your structure so sizing/snap works
      const inner = document.createElement('div');
      inner.className = 'product-slide-inner';
        inner.dataset.wmSpecialInner = '1';
      inner.style.overflow = 'hidden';
    
      inner.style.position = 'relative';
    
      // image (DOM-only, avoids template literal paste issues)
    const desktopImg = sc.image_desktop || sc.image_mobile;
    const mobileImg = sc.image_mobile || sc.image_desktop;

    if (sc.card_layout === 'app_popup') {
      if (typeof window.wmBuildSpecialPopupContent === 'function') {
        window.wmBuildSpecialPopupContent(inner, sc, desktopImg, mobileImg);
      }
    } else {
      if (desktopImg) {
        const picture = document.createElement('picture');
        picture.className = 'wm-special-card__media';

        if (mobileImg) {
          const source = document.createElement('source');
          source.setAttribute('media', '(max-width: 767px)');
          source.setAttribute('srcset', mobileImg);
          picture.appendChild(source);
        }

        const img = document.createElement('img');
        img.className = 'wm-special-card__img';
        img.src = desktopImg;
        img.alt = sc.alt || 'Wax Merchant';
        img.loading = 'lazy';
        picture.appendChild(img);

        inner.appendChild(picture);
      }

      if (sc.cta_url && sc.cta_text){
        const ctaWrap = document.createElement('div');
        ctaWrap.className = 'wm-special-cta';
        ctaWrap.style.cssText = 'position:absolute;left:16px;right:16px;bottom:16px;z-index:3;pointer-events:auto;';

        const btn = document.createElement('a');
        btn.className = 'wm-special-cta__btn ' + (sc.cta_style === 'outline' ? 'is-outline' : 'is-fill');
        btn.href = sc.cta_url;
        btn.textContent = sc.cta_text;

        if (sc.cta_new_tab){
          btn.target = '_blank';
          btn.rel = 'noopener';
        }

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
        });

        ctaWrap.appendChild(btn);
        inner.appendChild(ctaWrap);
      }

      if (sc.link_url){
        const a = document.createElement('a');
        a.href = sc.link_url;
        a.setAttribute('aria-label', sc.alt || 'Wax Merchant');
        a.style.cssText = 'position:absolute;inset:0;z-index:1;';

        if (sc.open_new_tab){
          a.target = '_blank';
          a.rel = 'noopener';
        }
        inner.appendChild(a);
      }
    }
    
      section.appendChild(inner);
      return section;
    }
    
    /**
     * Insert any special cards whose insert_after threshold
     * is now reached, based on total PRODUCT slides rendered.
     *
     * Call this after:
     *  - initial render
     *  - shuffle swap-in
     *  - lazy append
     *  - shuffle append
     */

function wmIsMobiLoudApp() {
  if (typeof window.WM_IS_APP === 'boolean') return window.WM_IS_APP;

  var ua = (navigator.userAgent || '').toLowerCase();
  var deviceData = window.deviceData || window.DeviceData || null;

  if (deviceData && deviceData.isCanvas === true) return true;
  if (ua.indexOf('canvas') !== -1) return true;

  var params = new URLSearchParams(window.location.search);
  if (params.get('wm_app') === '1') return true;

  return false;
}

const WM_IS_APP = wmIsMobiLoudApp();
     
    function wmMaybeInsertSpecialCards(container){
  const specials = (window.WM_SPECIAL_CARDS || [])
    .slice()
    .sort((a,b)=>a.insert_after-b.insert_after);

  if (!specials.length) return;

  container.querySelectorAll('.wm-special-card[data-wm-special-id]').forEach(el => {
    const id = el.getAttribute('data-wm-special-id');
    if (id) WM_SPECIAL.inserted.add(id);
  });

  const productsOnly = Array.from(container.querySelectorAll('.product-slide'))
    .filter(s => !s.classList.contains('wm-special-card') && s.dataset.wmSpecial !== '1');

  for (const sc of specials){
    if (!sc || !sc.id) continue;

    // WM: per-card app visibility
    if (sc.visibility === 'non_app_only' && WM_IS_APP) continue;
    if (sc.visibility === 'app_only' && !WM_IS_APP) continue;

    if (WM_SPECIAL.inserted.has(sc.id)) continue;

    const anchor = productsOnly[sc.insert_after - 1];
    if (!anchor) continue;

    const el = wmBuildSpecialCardEl(sc);
    el.setAttribute('data-wm-special-id', sc.id);
    el.setAttribute('data-wm-special', '1');

    anchor.insertAdjacentElement('afterend', el);
    WM_SPECIAL.inserted.add(sc.id);

    if (WM_PRODUCT_IO) WM_PRODUCT_IO.observe(el);
  }
}
    
    
    
      /* =========================================================
       WM RANDOM SHUFFLE ENGINE (Option A – full collection)
       Loads product HANDLES only (50 per page), shuffles client-side
    ========================================================= */
    
    let WM_HANDLE_POOL = [];
    let WM_HANDLE_CURSOR = 0;
    let WM_HANDLES_PAGE = 1;
    let WM_HANDLES_DONE = false;
    let WM_RENDERED_HANDLES = new Set(); // prevents repeats within the session
    let WM_UNIQUE_HANDLES = new Set();   // ✅ NEW: prevents duplicates entering the pool
    
    
    function wmIsShuffleMode(){
      const c = document.getElementById('verticalSwipeContainer');
      if (c && c.dataset && c.dataset.wmShuffle === '1') return true;
      const params = new URLSearchParams(window.location.search);
      return params.get('sort_by') === 'wm-random';
    }

    function wmBuildAjaxCardUrl(handle){
      const url = new URL(`/products/${encodeURIComponent(handle)}`, window.location.origin);
      url.searchParams.set('view', 'ajax-card');

      const current = new URL(window.location.href);
      const artist = current.searchParams.get('artist');
      const label = current.searchParams.get('label');
      const feedContainer = document.getElementById('verticalSwipeContainer');
      const filterSource = feedContainer?.dataset?.wmFilterSource || '';
      const filterValue = feedContainer?.dataset?.wmFilterValue || '';

      if (artist) url.searchParams.set('artist', artist);
      if (label) url.searchParams.set('label', label);
      if (!artist && !label) {
        if (filterSource === 'artist' && filterValue) {
          url.searchParams.set('artist', filterValue);
        }
        if (filterSource === 'label' && filterValue) {
          url.searchParams.set('label', filterValue);
        }
      }

      if (window.WM_FEED_SOURCE === 'wishlist') {
        url.searchParams.set('wm_feed_source', 'wishlist');
      }

      return url.pathname + '?' + url.searchParams.toString();
    }
    
      // ================================
      // WM: Show unlock overlay only once per TAB session
      // ================================
      const WM_OVERLAY_SEEN_KEY = 'wm_feed_unlock_seen_v1';
      let WM_AUTOBOOT_ALLOWED = !!WM_IS_APP; // app users can attempt autoplay immediately
    
      let overlay = document.getElementById('audioUnlockOverlay');
      const overlaySeen = sessionStorage.getItem(WM_OVERLAY_SEEN_KEY) === '1';
      if (overlay && WM_IS_APP) {
        overlay.remove();
        overlay = null;
      } else if (overlay) {
        document.documentElement.classList.toggle('wm-unlock-overlay-mini', overlaySeen);
      }

    // Autoboot only after an explicit user gesture (overlay tap OR play tap)
    WM_AUTOBOOT_ALLOWED = !!WM_IS_APP;
    
    
    
      
    
    
    function wmShuffleArray(arr){
      for (let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
    }
    
    /* Fetch ONE page of 50 handles */
    async function wmFetchHandlesPage(page){
      const url = `${window.location.pathname}?view=handles&page=${page}`;
    
      try {
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) return [];
    
        // Shopify theme views often come back as text/html even if the body is JSON.
        const txt = await res.text();
    
        // Try JSON first
        try {
          const json = JSON.parse(txt);
          return json.handles || [];
        } catch (e) {
          console.warn('[WM SHUFFLE] handles not JSON (check collection.handles template):', url);
          // Optional: log a snippet to help debug quickly
          console.warn(txt.slice(0, 200));
          return [];
        }
      } catch (e) {
        console.warn('[WM SHUFFLE] handles fetch failed:', e);
        return [];
      }
    }
    
    
    
    /* Ensure we have at least N unseen handles */
    async function wmEnsureHandlesAvailable(n){
      while ((WM_HANDLE_POOL.length - WM_HANDLE_CURSOR) < n && !WM_HANDLES_DONE){
        const next = await wmFetchHandlesPage(WM_HANDLES_PAGE);
    
        if (!next.length){
          WM_HANDLES_DONE = true;
          break;
        }
    
        for (const h of next) {
      if (!h) continue;
      if (WM_UNIQUE_HANDLES.has(h)) continue;
      WM_UNIQUE_HANDLES.add(h);
      WM_HANDLE_POOL.push(h);
    }
    WM_HANDLES_PAGE += 1;
    
      }
    }
    
    /* OPTION A — warm the ENTIRE collection in background */
    async function wmWarmAllHandles(container){
      const totalPages = parseInt(container?.dataset?.wmHandlesPages || '0', 10);
      if (!totalPages) return;
    
      for (let p = 1; p <= totalPages; p++){
        const next = await wmFetchHandlesPage(p);
        if (!next.length){
          // stop if a page returns empty
          break;
        }
    for (const h of next) {
      if (!h) continue;
      if (WM_UNIQUE_HANDLES.has(h)) continue;
      WM_UNIQUE_HANDLES.add(h);
      WM_HANDLE_POOL.push(h);
    }
    
        // yield to UI
        await new Promise(r => setTimeout(r, 0));
      }
    
      WM_HANDLES_DONE = true;
    }
    
    
    /* Load one RANDOM batch (6 like your current pagination) */
    async function wmLoadRandomBatch(container){
      await wmEnsureHandlesAvailable(6);
    
      const handles = WM_HANDLE_POOL.slice(WM_HANDLE_CURSOR, WM_HANDLE_CURSOR + 6);
    WM_HANDLE_CURSOR += handles.length;
    
    // If no more handles, show end message (like normal pagination)
    if (!handles.length) {
      if (endMessage) endMessage.style.display = 'block';
      return;
    }
    
    // If we’re about to exhaust the pool, show the end message after this batch
    if (WM_HANDLES_DONE && WM_HANDLE_CURSOR >= WM_HANDLE_POOL.length) {
      // we'll reveal it after append so user can scroll onto it naturally
      setTimeout(() => { if (endMessage) endMessage.style.display = 'block'; }, 0);
    }
    
    
      const htmlChunks = await Promise.all(
        handles.map(async (h) => {
          const ajaxCardUrl = wmBuildAjaxCardUrl(h);
  
  const res = await fetch(ajaxCardUrl, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
          if (!res.ok) return '';
          return await res.text();
        })
      );
    
      const newSlides = [];
    
      for (const html of htmlChunks) {
        if (!html) continue;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const slide = doc.querySelector('.product-slide');
        if (!slide) continue;
    
        const node = document.importNode(slide, true);
        container.appendChild(node);
        newSlides.push(node);
      }
    
      if (!newSlides.length) return;
    
      initializeSwiperForSlides(newSlides);
      newSlides.forEach(slide => initializeAudioControlsForProduct(slide));
      wmInitTitleMarquees(container);
      wmObserveNewMarqueeCards(newSlides);
      wmMaybeInsertSpecialCards(container);
    
    
      newSlides.forEach(slide => { if (WM_PRODUCT_IO) WM_PRODUCT_IO.observe(slide); });
    }
    
    
    
    /* First load */
    async function wmInitShuffle(container){
      if (!container) return;
    
      WM_SHUFFLE_BOOTING = true;
    
      WM_HANDLE_POOL = [];
    WM_HANDLE_CURSOR = 0;
    WM_HANDLES_PAGE = 1;
    WM_HANDLES_DONE = false;
    
    WM_RENDERED_HANDLES = new Set();
    WM_UNIQUE_HANDLES = new Set(); // ✅ NEW reset
    
    
    
      // show spinner during shuffle boot (optional but helps perception)
      if (loadingIndicator) loadingIndicator.style.display = 'block';
    
      // 1) Get enough handles for the first 6 (fast)
      await wmEnsureHandlesAvailable(6);
    
      // If handles failed, keep server-rendered slides and allow normal autoplay
      if ((WM_HANDLE_POOL.length - WM_HANDLE_CURSOR) < 1) {
        console.warn('[WM SHUFFLE] No handles returned — leaving initial server batch.');
        WM_SHUFFLE_BOOTING = false;
        if (loadingIndicator) loadingIndicator.style.display = 'none';
        return;
      }
    
      // Shuffle what we have now (we'll append more later, and re-shuffle pool once warmed)
      wmShuffleArray(WM_HANDLE_POOL);
    
      // 2) Prefetch first 6 cards BEFORE touching the DOM
      const handles = WM_HANDLE_POOL.slice(WM_HANDLE_CURSOR, WM_HANDLE_CURSOR + 6);
      WM_HANDLE_CURSOR += handles.length;
    
      const htmlChunks = await Promise.all(handles.map(async (h) => {
        const ajaxCardUrl = wmBuildAjaxCardUrl(h);
  
  const res = await fetch(ajaxCardUrl, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
        if (!res.ok) return '';
        return await res.text();
      }));
    
      // Robust parse: supports fragments or full HTML docs
      const slides = [];
      for (const html of htmlChunks) {
        if (!html) continue;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const found = doc.querySelector('.product-slide');
        if (found) slides.push(found);
      }
    
      if (!slides.length) {
        console.warn('[WM SHUFFLE] ajax-card returned no .product-slide — leaving initial server batch.');
        WM_SHUFFLE_BOOTING = false;
        if (loadingIndicator) loadingIndicator.style.display = 'none';
        return;
      }
    
      // Pause anything that may have started (prevents “featured starts then cuts”)
      if (WM_OWNER.slide) {
        wmPauseSlide(WM_OWNER.slide);
        const oldBtn = WM_OWNER.slide.querySelector('.play-pause-button');
        setButtonToPlay(oldBtn);
      }
    
      
    
      // 3) Swap instantly
        // IMPORTANT: we're about to remove Liquid-rendered specials too.
      // Reset inserted set so specials can be re-inserted for the shuffled batch.
      WM_SPECIAL.inserted = new Set();
      WM_SPECIAL.productCount = 0;
    
      container.querySelectorAll('.product-slide').forEach(s => s.remove());
    
      slides.forEach(s => {
        const node = document.importNode(s, true);
        container.appendChild(node);
      });
    
      const injectedSlides = Array.from(container.querySelectorAll('.product-slide'));
    
      // Make first shuffled covers load like your server-rendered batch
    injectedSlides.forEach((ps, idx) => {
      const cover = ps.querySelector('.audio-cover');
      wmEnhanceCoverImage(cover, idx);
    });
    
    
      // 4) Init behaviours on injected slides
      initializeSwiperForSlides(injectedSlides);
      injectedSlides.forEach(slide => initializeAudioControlsForProduct(slide));
      wmInitTitleMarquees(container);
      wmObserveNewMarqueeCards(injectedSlides);
      wmMaybeInsertSpecialCards(container);
      wmSafariLazyImageFix(container);
    
    
    
      injectedSlides.forEach(slide => { if (WM_PRODUCT_IO) WM_PRODUCT_IO.observe(slide); });
    
     // 5) Boot done — decide what happens next
    WM_SHUFFLE_BOOTING = false;
    if (loadingIndicator) loadingIndicator.style.display = 'none';
    
    document.documentElement.classList.remove('wm-shuffle-boot');
    
    // If we dismissed overlay during boot, autoplay now
    if (WM_PENDING_AUTOBOOT && WM_MEDIA_UNLOCKED) {
      WM_PENDING_AUTOBOOT = false;
      kickVisibleSlide();
    } else if (!WM_AUTOBOOT_ALLOWED) {
      setTimeout(() => wmPromptPlayOnFirstVisible(), 0);
    } else {
      if (WM_MEDIA_UNLOCKED) kickVisibleSlide();
      else if (WM_IS_APP) {
        wmUnlockAudioOnce().then(() => {
          if (WM_MEDIA_UNLOCKED) kickVisibleSlide();
        }).catch(() => {});
      }
    }
    
    
    // 6) Warm remaining handles in background (so infinite scroll stays strong)
    wmWarmAllHandles(container).then(() => {
      const used = WM_HANDLE_CURSOR;
      const remaining = WM_HANDLE_POOL.slice(used);
      wmShuffleArray(remaining);
      WM_HANDLE_POOL = WM_HANDLE_POOL.slice(0, used).concat(remaining);
      WM_HANDLES_DONE = true;
    }).catch(()=>{});
    }
    
    
    
    
    
      const container = document.getElementById('verticalSwipeContainer');
      console.log('WM container found:', !!container, container);
      // ================================
    // WM: iOS scroll-snap stabiliser (end-of-feed bounce fix)
    // ================================
    const WM_IS_IOS = (() => {
      const ua = navigator.userAgent || '';
      const platform = navigator.platform || '';
      const iOS = /iP(ad|hone|od)/.test(platform);
      const iPadOS = (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      return iOS || iPadOS || /Safari/.test(ua) && /Mobile/.test(ua);
    })();
    
    
    
    
    
    function wmSnapToNearestProductSlide(){
      if (!container) return;
      if (!WM_IS_IOS) return;
      if (isLoading) return;
    
      // Only stabilize at feed edges (prevents mid-feed forced snap-back)
      const edgeThreshold = 36;
      const atTopEdge = container.scrollTop <= edgeThreshold;
      const atBottomEdge = (container.scrollTop + container.clientHeight) >= (container.scrollHeight - edgeThreshold);
      if (!atTopEdge && !atBottomEdge) return;
    
      const slides = Array.from(container.querySelectorAll('.product-slide'));
      if (!slides.length) return;
    
      const y = container.scrollTop;
      let best = slides[0];
      let bestDist = Infinity;
    
      for (const s of slides){
        const top = s.offsetTop;
        const d = Math.abs(top - y);
        if (d < bestDist){
          bestDist = d;
          best = s;
        }
      }
    
      // Relaxed nudge threshold (was 6)
      const snapTolerance = Math.max(72, Math.round(container.clientHeight * 0.12));
      if (best && bestDist > snapTolerance){
        container.scrollTo({ top: best.offsetTop, behavior: 'auto' });
      }
    }
    
    
    // Debounce: run after momentum scrolling finishes
    let wmSnapTimer = null;
    if (container) {
    container.addEventListener('scroll', () => {
      if (scrollThrottle) return;
      scrollThrottle = true;
  
      setTimeout(async () => {
        scrollThrottle = false;
        if (isLoading) return;
  
        const source = wmGetCurrentIndexSource();
        if (!wmIsShuffleMode() && window.WM_INDEX_CURSOR >= source.length) {
          if (endMessage) endMessage.style.display = 'block';
          return;
        }
  
        const scrollPos = container.scrollTop + container.clientHeight;
        const triggerPoint = container.scrollHeight - 1400;
  
        if (scrollPos >= triggerPoint) {
          await wmWaitForCollectionIndex();
  
          if (wmIsShuffleMode() && !wmShouldPrioritizePinnedHandle()) {
            if (WM_HANDLES_DONE && WM_HANDLE_CURSOR >= WM_HANDLE_POOL.length) {
              if (endMessage) endMessage.style.display = 'block';
              return;
            }
            wmLoadRandomBatch(container);
          } else {
            await loadNextPage();
          }
        }
      }, 150);
    });
  }
    
    if (document.documentElement.classList.contains('wm-prepinned')) {
      setTimeout(() => document.documentElement.classList.remove('wm-prepinned'), 2000);
    }
    
    
      (function wmForcePinnedStartNoSmooth(){
      if (!container) return;
    
      const params = new URLSearchParams(window.location.search);
      const hasPinned = !!params.get('p');
      const isReturn = params.get('wm_return') === '1';
    
      // Only force top for pinned links (not “return to feed” restores)
      if (!hasPinned || isReturn) return;
    
      // Stop browser restoring scroll (Safari especially)
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    
      // Kill smooth behavior while we reset scroll positions
      container.classList.add('wm-no-smooth');
    
      // Reset *both* window and container (some browsers restore one or the other)
      const goTop = () => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        container.scrollTop = 0;
      };
    
      goTop();
      requestAnimationFrame(goTop);
      setTimeout(goTop, 50);
      setTimeout(goTop, 150);
    
      // Re-enable smooth scrolling after initial stabilisation
      setTimeout(() => {
        container.classList.remove('wm-no-smooth');
      }, 400);
    })();
    
      
      // --- Force start at top when using pinned links (?p=...), unless returning from filter ---
    (function wmForcePinnedStart(){
      if (!container) return;
    
      const params = new URLSearchParams(window.location.search);
      const hasPinned = !!params.get('p');
      const isReturn = params.get('wm_return') === '1';
    
      if (!hasPinned || isReturn) return;
    
      // Stop the browser from restoring scroll position (especially iOS Safari)
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    
      // Hard reset container scroll a few times to beat late layout / image loads
      const goTop = () => { container.scrollTop = 0; };
    
      goTop();
      requestAnimationFrame(goTop);
      setTimeout(goTop, 50);
      setTimeout(goTop, 150);
      setTimeout(goTop, 300);
    })();
    
    
    // --- PINNED PRODUCT: read ?p=HANDLE from the URL and inject the slide ---
    const pinnedHandle = wmGetPinnedHandleFromUrl();
    if (pinnedHandle && window.WM_FEED_SOURCE === 'recommendations') {
      wmInsertPinnedCard(pinnedHandle);
    }
    
    
        // ================================
      // WM PINNED PRODUCT (inject full audio card)
      // Fetches: /products/HANDLE?view=pinned-product-card
      // ================================
      function wmGetPinnedHandleFromUrl() {
        try { return new URLSearchParams(window.location.search).get('p') || ''; }
        catch (e) { return ''; }
      }

      function wmShouldPrioritizePinnedHandle() {
        try {
          const params = new URLSearchParams(window.location.search);
          return !!(params.get('p') && params.get('wm_return') !== '1');
        } catch (e) {
          return false;
        }
      }

      function wmPinnedFallbackItem(handle) {
      const item = {
        handle: handle,
        product_handle: handle,
        available: false
      };

        try {
          const debug = document.getElementById('wmPinnedDebug');
          const debugHandle = debug?.dataset?.handle || debug?.dataset?.p || '';
          const debugAvailable = debug?.dataset?.available || '';
          if (debug && debugHandle === handle && debugAvailable !== '') {
            item.available = debugAvailable === 'true' || debugAvailable === '1';
          }
        } catch (e) {}

        return item;
      }

      async function wmFetchPinnedProductState(handle) {
        try {
          const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
            headers: { 'Accept': 'application/json' }
          });

          if (!res.ok) return wmPinnedFallbackItem(handle);

          const product = await res.json();

          return {
            handle: product?.handle || handle,
            product_handle: product?.handle || handle,
            id: product?.id || '',
            product_id: product?.id || '',
            available: !!product?.available,
            tags: Array.isArray(product?.tags) ? product.tags : []
          };
        } catch (e) {
          return wmPinnedFallbackItem(handle);
        }
      }

      async function wmFetchPinnedSlide(handle) {
        const urls = [
          `/products/${encodeURIComponent(handle)}?view=pinned-product-card`,
          wmBuildAjaxCardUrl(handle)
        ];

        for (const url of urls) {
          try {
            const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!res.ok) continue;

            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const slide = doc.querySelector('.product-slide');

            if (slide) return slide;
          } catch (e) {}
        }

        return null;
      }
    
      async function wmInsertPinnedCard(handle) {
        if (!handle || !container) return;
    
        // prevent duplicate insert
        if (container.querySelector('.product-slide[data-wm-pinned="1"]')) {
          document.documentElement.classList.remove('wm-prepinned');
          return;
        }
    
    
        try {
          const [pinnedSlide, pinnedItem] = await Promise.all([
            wmFetchPinnedSlide(handle),
            wmFetchPinnedProductState(handle)
          ]);

          if (!pinnedSlide) {
            document.documentElement.classList.remove('wm-prepinned');
            return;
          }
    
          // Import node into this document
          const node = document.importNode(pinnedSlide, true);
          node.setAttribute('data-wm-pinned', '1');

          if (!node.getAttribute('data-product-handle')) {
            node.setAttribute('data-product-handle', handle);
          }

          if (pinnedItem && Object.prototype.hasOwnProperty.call(pinnedItem, 'available')) {
            node.setAttribute('data-wm-available', pinnedItem.available ? '1' : '0');
          }
    
          container.prepend(node);
          wmApplyPinnedStockState(node, pinnedItem || wmPinnedFallbackItem(handle));
    
          document.documentElement.classList.remove('wm-prepinned');
    container.scrollTop = 0;
    
    
          // Init all behaviors on the inserted slide
          const inserted = container.querySelector('.product-slide[data-wm-pinned="1"]') || container.querySelector('.product-slide');
          if (inserted) {
            initializeSwiperForSlides([inserted]);
            initializeAudioControlsForProduct(inserted);
            wmInitTitleMarquees(container);
            if (typeof wmObserveNewMarqueeCards === 'function') wmObserveNewMarqueeCards([inserted]);
          }
    
          container.scrollTop = 0;
    
        } catch (e) {
          document.documentElement.classList.remove('wm-prepinned');
        }
      }
    
       
    let WM_PENDING_RETURN = null;
    let WM_RETURN_RESTORE_ACTIVE = false;

    function wmBuildComparableUrl(urlLike) {
      try {
        const url = new URL(urlLike, window.location.origin);
        url.searchParams.delete('wm_return');
        return url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '');
      } catch (e) {
        return '';
      }
    }
    
    try {
      const saved = JSON.parse(sessionStorage.getItem('wm_feed_return') || 'null');
      const params = new URLSearchParams(window.location.search);
    
      // Only restore when we came back from the clear-filter pill
      const currentComparableUrl = wmBuildComparableUrl(window.location.href);
      const savedComparableUrl = saved?.originUrl ? wmBuildComparableUrl(saved.originUrl) : '';

      const isAuthReturn = sessionStorage.getItem('wm_auth_return_pending') === '1';

      if (
        saved &&
        params.get('wm_return') === '1' &&
        (
          isAuthReturn ||
          (
            savedComparableUrl &&
            savedComparableUrl === currentComparableUrl
          )
        )
      ) {
        WM_PENDING_RETURN = saved;
      } else if (params.get('wm_return') === '1') {
        sessionStorage.removeItem('wm_feed_return');
        sessionStorage.removeItem('wm_auth_return_pending');
      }
    } catch (e) {}
    
    document.addEventListener('click', (e) => {
      const clearPill = e.target.closest('.wm-filter-sticker'); // your “filter” sticker / clear pill
      if (!clearPill) return;
    
      try {
        const saved = JSON.parse(sessionStorage.getItem('wm_feed_return') || 'null');
        if (!saved?.originUrl) return; // fallback to href if missing
    
        e.preventDefault();
        e.stopPropagation();
    
        const u = new URL(saved.originUrl, window.location.origin);

        const isWishlistOrigin =
          u.pathname === '/apps/wishlist' ||
          u.pathname === '/pages/wishlist-feed' ||
          u.pathname.endsWith('/wishlist-feed') ||
          document.body.classList.contains('wm-feed-source-wishlist');

        if (isWishlistOrigin) {
          window.location.href = '/collections/all-records?sort_by=created-descending';
          return;
        }
    
        // ensure we trigger restore logic on return
        u.searchParams.set('wm_return', '1');
    
        window.location.href = u.pathname + (u.search ? u.search : '');
      } catch (err) {
        // if anything fails, let the normal href happen
      }
    }, true);
    
    
    // Find the "current" slide at the top of the viewport (best anchor)
    function wmGetAnchorSlide() {
      if (!container) return null;
      const slides = Array.from(
        container.querySelectorAll('.product-slide[data-product-handle]')
      ).filter((slide) => !wmIsSpecialCard(slide));
      if (!slides.length) return null;
    
      // anchor line: a little below the top so it feels natural
      const anchorY = container.scrollTop + 40;
    
      let best = slides[0];
      let bestDist = Infinity;
    
      for (const s of slides) {
        const top = s.offsetTop;
        const dist = Math.abs(top - anchorY);
        if (dist < bestDist) {
          best = s;
          bestDist = dist;
        }
      }
      return best;
    }

    function wmSaveFeedReturnState(){
      if (!container) return;

      const anchor = wmGetAnchorSlide();
      const handle = anchor?.dataset?.productHandle || null;
      const offsetInSlide = anchor ? (container.scrollTop - anchor.offsetTop) : 0;
      const source = wmGetCurrentIndexSource();
      const sourceIndex = handle
        ? source.findIndex((item) => (item?.handle || item?.product_handle) === handle)
        : -1;

      sessionStorage.setItem('wm_feed_return', JSON.stringify({
        originUrl: window.location.pathname + window.location.search,
        productHandle: handle,
        sourceIndex: sourceIndex,
        offsetInSlide: offsetInSlide,
        scrollTop: container.scrollTop,
        ts: Date.now()
      }));
    }
    
    // 1) Remember position before entering a filter
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.wm-artist-link, .wm-label-link');
      if (!link || !container) return;

      const isCurrentlyFiltered = !!(
        container?.dataset?.wmFilterSource &&
        container?.dataset?.wmFilterValue
      );

      if (isCurrentlyFiltered) {
        try {
          const existingReturn = JSON.parse(sessionStorage.getItem('wm_feed_return') || 'null');
          if (existingReturn?.originUrl) {
            console.log('[WM RETURN] preserve-existing', {
              href: window.location.href,
              existingReturn
            });
            return;
          }
        } catch (err) {}
      }
    
      wmSaveFeedReturnState();
    }, true);
    
    
    
    
    
       
    
    
      const loadingIndicator = document.getElementById('loadingIndicator');
      const endMessage = document.getElementById('endOfFeedMessage');
    
      const filterDropdown = document.getElementById('filterOptions');
      if (filterDropdown) {
        filterDropdown.addEventListener('change', function () {
      const selectedUrl = this.value;
      if (!selectedUrl) return;
    
      try {
        const current = new URL(window.location.href);
        const next = new URL(selectedUrl, window.location.origin);
    
        // Carry across tracking params
    const keepKeys = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","utm_id"];
    keepKeys.forEach(k => {
      const v = current.searchParams.get(k);
      if (v && !next.searchParams.get(k)) next.searchParams.set(k, v);
    });
    
    // Conditionally carry pinned (?p=...) ONLY if pinned belongs to destination collection
    const pinned = current.searchParams.get("p");
    if (pinned) {
      const dbg = document.getElementById("wmPinnedDebug");
      const cols = (dbg?.dataset?.collections || "")
        .split(",")
        .map(s => s.trim())
        .filter(Boolean);
    
      // destination collection handle from /collections/HANDLE
      const parts = next.pathname.split("/").filter(Boolean);
      const destHandle = parts[0] === "collections" ? (parts[1] || "") : "";
    
      if (destHandle && cols.includes(destHandle)) {
        next.searchParams.set("p", pinned);
      } else {
        next.searchParams.delete("p");
      }
    }
    
    
        // Also preserve current sort_by if present (useful when switching feeds)
        const sortBy = current.searchParams.get("sort_by");
        if (sortBy && !next.searchParams.get("sort_by")) next.searchParams.set("sort_by", sortBy);
    
        if (next.toString() !== current.toString()) window.location.href = next.toString();
      } catch (e) {
        // fallback
        window.location.href = selectedUrl;
      }
    });
    
      }
      
      // Lock the document scroll while this section is mounted
    document.documentElement.classList.add('wm-feed-lock');
    document.body.classList.add('wm-feed-lock');
    
    // Prevent stray touches from scrolling the page (mobile Safari)
    window.addEventListener('touchmove', function (e) {
      if (!e.target.closest('#verticalSwipeContainer')) {
        e.preventDefault();
      }
    }, { passive: false });
    
    
    
    // If you ever navigate away via AJAX, you can clean up like this:
    // window.addEventListener('beforeunload', () => {
    //   document.documentElement.classList.remove('wm-feed-lock');
    //   document.body.classList.remove('wm-feed-lock');
    // });
    
    
      let currentPage = parseInt(container.dataset.currentPage || '1', 10);
      const totalPages = parseInt(container.dataset.totalPages || '1', 10);
      const sortBy = container.dataset.sortBy || '';
      const collectionHandle = container.dataset.collectionHandle || '';
    
      // unlock overlay
    async function unlockAudioPlayback(e) {
      if (WM_OVERLAY_UNLOCKING) return;
      WM_OVERLAY_UNLOCKING = true;
      e.preventDefault();
      e.stopPropagation();
    
      // This gesture IS consent for autoplay this session
      WM_AUTOBOOT_ALLOWED = true;
      WM_PENDING_AUTOBOOT = true;
    
      // Mark overlay as seen so it won't show again this session
      try { sessionStorage.setItem(WM_OVERLAY_SEEN_KEY, '1'); } catch(err){}
    
      // Unlock audio in this gesture
      if (!WM_MEDIA_UNLOCKED) {
        await wmUnlockAudioOnce();
      }
    
      // Remove overlay
      overlay?.remove();
      overlay = null;
      document.documentElement.classList.remove('wm-unlock-overlay-mini');
    
      // If shuffle is still swapping, let shuffle finish then autoplay
      if (wmIsShuffleMode() && WM_SHUFFLE_BOOTING) return;
    
      // Next frame so Swiper/layout is ready
      requestAnimationFrame(() => {
        if (WM_PENDING_AUTOBOOT) kickVisibleSlide();
      });
    }
    
    
    
    
      overlay?.addEventListener('click', unlockAudioPlayback, { passive:false });
      overlay?.addEventListener('touchend', unlockAudioPlayback, { passive:false });
      ['touchstart','pointerdown','mousedown','keydown'].forEach(ev=>{
        window.addEventListener(ev, () => wmUnlockAudioOnce(), { once:true, capture:true, passive:true });
      });
    
      let isLoading = false;
      const slideObservers = new Map();

    function wmShouldPinPlayPrompt(){
      return !WM_IS_APP && !overlay && !WM_AUTOBOOT_ALLOWED && !WM_MEDIA_UNLOCKED;
    }
    
    // WM: show controls with fade-in (no double toggle → no flicker)
    function wmShowControlsForSlide(slide){
      const carousel = slide?.closest?.('.audio-player-carousel');
      if (!carousel) return;
    
      clearTimeout(carousel.hideControlsTimer);
    
      // Just reveal (CSS handles fade because we start hidden)
      carousel.classList.remove('hide-controls');

      if (wmShouldPinPlayPrompt()) {
        return;
      }
    
      carousel.hideControlsTimer = setTimeout(() => {
        carousel.classList.add('hide-controls');
      }, 2000);
    }
    // WM: toggle controls visibility on tap (mobile friendly)
    function wmToggleControlsForSlide(slide){
      const carousel = slide?.closest?.('.audio-player-carousel');
      if (!carousel) return;
    
      const isHidden = carousel.classList.contains('hide-controls');
    
      if (isHidden) {
        wmShowControlsForSlide(slide);   // fade in using existing logic
      } else {
        if (wmShouldPinPlayPrompt()) return;
        clearTimeout(carousel.hideControlsTimer);
        carousel.classList.add('hide-controls'); // hide immediately
      }
    }
    
    
    
    
    
    
    /* ================================
       Title marquee: auto-run once per card when fully in view
       - waits, scrolls to end, pauses, returns to start
       - does NOT repeat unless user leaves card + comes back
    ================================ */
    
    // 1) Mark which titles are actually truncated + set distance/duration CSS vars
    function wmInitTitleMarquees(root = container) {
      if (!root) return;
      const titles = root.querySelectorAll('.wm-title-marquee');
      titles.forEach(el => {
        const inner = el.querySelector('.wm-title-marquee__inner');
        if (!inner) return;
    
        // reset truncation flags + vars
        el.classList.remove('wm-title--truncated', 'wm-title--play');
        el.style.removeProperty('--wm-marquee-distance');
        el.style.removeProperty('--wm-marquee-duration');
    
        // allow accurate measurement
        const available = el.clientWidth;
        const full = inner.scrollWidth;
    
        if (full > available + 2) {
          el.classList.add('wm-title--truncated');
    
          const distance = (full - available) + 18; // include a little breathing room
          el.style.setProperty('--wm-marquee-distance', String(distance)); // NO px
    
    
          const seconds = Math.min(12, Math.max(6, distance / 40));
          el.style.setProperty('--wm-marquee-duration', `${seconds}s`);
        }
    
        // ensure fresh state
        el.dataset.wmMarqueePlayed = '0';
      });
    }
    
    // 2) Run marquee sequence once (play -> pause -> return)
    function wmRunMarqueeOnce(titleEl) {
      if (!titleEl || titleEl.dataset.wmMarqueeRunning === '1') return;
    
      // Only if truncated
      if (!titleEl.classList.contains('wm-title--truncated')) return;
    
      titleEl.dataset.wmMarqueeRunning = '1';
      titleEl.dataset.wmMarqueePlayed = '1';
    
      // start animation (forward scroll)
      titleEl.classList.remove('wm-title--play');
      void titleEl.offsetWidth; // restart
      titleEl.classList.add('wm-title--play');
    
      // read duration from CSS var
      const durRaw = getComputedStyle(titleEl).getPropertyValue('--wm-marquee-duration').trim();
      const dur = parseFloat(durRaw) || 8;
    
      // after it reaches the end, pause, then return to start
      clearTimeout(titleEl._wmMarqueeEndTimer);
      clearTimeout(titleEl._wmMarqueeReturnTimer);
    
      titleEl._wmMarqueeEndTimer = setTimeout(() => {
        // pause at end
        titleEl.classList.add('wm-title--at-end');
    
        // return to start (remove play + at-end so it snaps/truncates again)
        titleEl._wmMarqueeReturnTimer = setTimeout(() => {
          titleEl.classList.remove('wm-title--play');
          titleEl.classList.remove('wm-title--at-end');
          titleEl.dataset.wmMarqueeRunning = '0';
        }, 900); // pause time at end
      }, dur * 1000);
    }
    
    function wmSetupAutoTitleMarquee() {
      if (!container) return;
      if (container._wmTitleMarqueeObserver) return;
    
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      const threshold = isDesktop ? 0.60 : 0.85;
    
      // helper: run one marquee and return how long it will take (ms)
      function runOne(el){
        if (!el) return 0;
        if (!el.classList.contains('wm-title--truncated')) return 0;
        if (el.dataset.wmMarqueeRunning === '1') return 0;
    
        // mark it as played for this in-view session
        el.dataset.wmMarqueeRunning = '1';
        el.dataset.wmMarqueePlayed  = '1';
    
        el.classList.remove('wm-title--play', 'wm-title--at-end');
        void el.offsetWidth; // restart
        el.classList.add('wm-title--play');
    
        const durRaw = getComputedStyle(el).getPropertyValue('--wm-marquee-duration').trim();
        const durSec = parseFloat(durRaw) || 8;
    
        // pause at end a bit, then reset
        clearTimeout(el._wmMarqueeEndTimer);
        clearTimeout(el._wmMarqueeReturnTimer);
    
        el._wmMarqueeEndTimer = setTimeout(() => {
          el.classList.add('wm-title--at-end');
    
          el._wmMarqueeReturnTimer = setTimeout(() => {
            el.classList.remove('wm-title--play', 'wm-title--at-end');
            el.dataset.wmMarqueeRunning = '0';
          }, 900);
        }, durSec * 1000);
    
        // total time = duration + end pause
        return (durSec * 1000) + 900;
      }
    
      async function runSequence(card){
        if (!card) return;
    
        // grab BOTH marquees explicitly
        const artistEl = card.querySelector('.wm-artist-line.wm-title-marquee');
        const titleEl = card.querySelector('.wm-release-title.wm-title-marquee');
    
        // don’t rerun if we already ran while this card stayed in view
        const key = 'wmMarqueeSeqPlayed';
        if (card.dataset[key] === '1') return;
        card.dataset[key] = '1';
    
        // artist first
        const t1 = runOne(artistEl);
    
        // then title after artist finishes (+ a small gap so it feels intentional)
        const gap = 250;
        setTimeout(() => { runOne(titleEl); }, Math.max(0, t1) + gap);
      }
    
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const card = entry.target;
    
          if (entry.isIntersecting) {
            // delay before starting the sequence
            clearTimeout(card._wmMarqueeStartTimer);
            card._wmMarqueeStartTimer = setTimeout(() => {
              runSequence(card);
            }, 900);
          } else {
            // leaving view: allow it to run again next time
            clearTimeout(card._wmMarqueeStartTimer);
            card.dataset.wmMarqueeSeqPlayed = '0';
    
            // reset both marquees cleanly
            card.querySelectorAll('.wm-title-marquee').forEach(el => {
              clearTimeout(el._wmMarqueeEndTimer);
              clearTimeout(el._wmMarqueeReturnTimer);
              el.classList.remove('wm-title--play', 'wm-title--at-end');
              el.dataset.wmMarqueePlayed = '0';
              el.dataset.wmMarqueeRunning = '0';
            });
          }
        });
      }, { root: container, threshold });
    
      container.querySelectorAll('.product-slide').forEach(card => io.observe(card));
      container._wmTitleMarqueeObserver = io;
    }
    
    
    // 4) When you lazy-load more slides, observe them too
    function wmObserveNewMarqueeCards(newSlides) {
      if (!container?._wmTitleMarqueeObserver) return;
      newSlides.forEach(slide => container._wmTitleMarqueeObserver.observe(slide));
    }
    /* ================================
       Run title marquee ONCE (play → pause → reset)
    ================================ */
    function wmRunTitleMarqueeOnce(titleEl){
      if (!titleEl) return;
    
      // Only if truncated
      if (!titleEl.classList.contains('wm-title--truncated')) return;
    
      // Prevent repeat while card stays in view
      if (titleEl.dataset.wmMarqueeRan === '1') return;
      titleEl.dataset.wmMarqueeRan = '1';
    
      const inner = titleEl.querySelector('.wm-title-marquee__inner');
      if (!inner) return;
    
      // Lock width during animation (prevents jitter)
      inner.style.width = `${inner.scrollWidth}px`;
    
      // Start after a short delay so it feels intentional
      const startDelay = 450;
    
      setTimeout(() => {
        // Play marquee
        titleEl.classList.add('wm-title--play');
    
        // Read duration from CSS variable
        const durRaw = getComputedStyle(titleEl)
          .getPropertyValue('--wm-marquee-duration')
          .trim();
        const durationMs = (parseFloat(durRaw) || 8) * 1000;
    
        const pauseAtEndMs = 650;
    
        // After reaching end → pause → reset cleanly
        setTimeout(() => {
          titleEl.classList.remove('wm-title--play');
    
          // Hard reset transform without animation
          inner.style.animation = 'none';
          inner.style.transform = 'translate3d(0,0,0)';
          void inner.offsetHeight; // force reflow
          inner.style.animation = '';
    
          // Unlock width
          inner.style.width = '';
        }, durationMs + pauseAtEndMs);
    
      }, startDelay);
    }
    
    // 5) Recalc on resize
    let wmTitleResizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(wmTitleResizeTimer);
      wmTitleResizeTimer = setTimeout(() => wmInitTitleMarquees(container), 150);
    }, { passive: true });
    
    
      function initializeAudioControlsForSlide(slide) {
        if (slideObservers.has(slide)) {
          const { observer, cleanup } = slideObservers.get(slide);
          observer.disconnect(); cleanup(); slideObservers.delete(slide);
        }
    
        const button = slide.querySelector('.play-pause-button');
        const filled = slide.querySelector('.progress-filled');
        const dot = slide.querySelector('.progress-dot');
        const bar = slide.querySelector('.progress-bar');
        const barWrapper = slide.querySelector('.progress-bar-wrapper');
        const cover = slide.querySelector('.clickable-cover');

        setButtonToPlay(button);
    
        async function playAudio() {
      // Update UI immediately (prevents icon "lag" behind the circle on iOS)
      setButtonToPause(button);
    
      wmSafePlaySlide(slide, { unmute: true }).then(() => {
        // If play didn't actually start, revert icon
        if (!WM_MEDIA_UNLOCKED || (WM_PLAYER && WM_PLAYER.paused)) {
          setButtonToPlay(button);
        } else {
          WM_PENDING_AUTOBOOT = false; // ✅ success
        }
      });
    }
    
    function pauseAudio() {
      wmPauseSlide(slide);
      setButtonToPlay(button);
    }
    
    
        function resetFade() { wmShowControlsForSlide(slide); }
        // WM: tap-to-toggle controls (iOS-safe). Uses pointer events + movement threshold.
    let wmTapStartX = 0;
    let wmTapStartY = 0;
    let wmTapMoved = false;
    
    function wmIsRealControlTarget(t){
      return !!t.closest(
        '.play-pause-button,' +
        '.progress-bar-wrapper,' +
        '.progress-bar,' +
        '.swiper-button-next,' +
        '.swiper-button-prev,' +
        '.swiper-pagination'
      );
    }
    
    function wmOnPointerDownForToggle(e){
      // only primary touch/pointer
      if (e.isPrimary === false) return;
    
      wmTapMoved = false;
      wmTapStartX = e.clientX || 0;
      wmTapStartY = e.clientY || 0;
    }
    
    function wmOnPointerMoveForToggle(e){
      if (e.isPrimary === false) return;
      const dx = Math.abs((e.clientX || 0) - wmTapStartX);
      const dy = Math.abs((e.clientY || 0) - wmTapStartY);
      if (dx > 8 || dy > 8) wmTapMoved = true; // movement threshold = not a tap
    }
    
    function wmOnPointerUpForToggle(e){
      if (e.isPrimary === false) return;
    
      // If user interacted with real controls (play/pause, scrub, arrows), don't toggle overlay
      if (wmIsRealControlTarget(e.target)) return;
    
      // If finger moved, it's a scroll/drag, not a tap
      if (wmTapMoved) return;
    
      wmToggleControlsForSlide(slide);
    }
    
    
    
    const clickHandler = async (e) => {
      e.preventDefault();
      e.stopPropagation();
    
      // ✅ NEW: if controls are hidden, first tap ONLY reveals controls (no play/pause)
      const carousel = slide?.closest?.('.audio-player-carousel');
      if (carousel && carousel.classList.contains('hide-controls')) {
        wmShowControlsForSlide(slide);
        return;
      }
    
      // User explicitly pressed play/pause -> allow autoplay boot for session
      WM_AUTOBOOT_ALLOWED = true;
      try { sessionStorage.setItem(WM_OVERLAY_SEEN_KEY, '1'); } catch(e){}
    
      // Ensure audio is unlocked from THIS gesture (important when overlay is skipped)
      if (!WM_MEDIA_UNLOCKED) {
        await wmUnlockAudioOnce();
      }

      if (carousel) {
        clearTimeout(carousel.hideControlsTimer);
      }
    
      (WM_OWNER.slide !== slide || WM_PLAYER?.paused) ? playAudio() : pauseAudio();
    };
    
    
    if (slide.__wmBound) return;
    slide.__wmBound = true;
    
    
    button?.addEventListener('click', clickHandler);
    button?.addEventListener('touchend', clickHandler);
    
    
        // ---- Scrub with pointer events; lock Swiper while scrubbing ----
    (function initScrub(){
      if (!barWrapper || !bar) return;
    
      const carousel = slide.closest('.audio-player-carousel');
      const swiper = carousel?.swiperInstance;
      let scrubbing = false;
      let hadCapture = false;
    
      // Convert clientX to percent on the bar
      function posToPercent(clientX) {
        const rect = bar.getBoundingClientRect();
        const percent = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
        return percent;
      }
    
      // Ensure the singleton player is wired to THIS slide (without forcing play)
      async function ensurePlayerForThisSlide() {
        // If this slide doesn't own the player, load its source but don't autoplay.
        if (WM_OWNER.slide !== slide) {
          const player = wmCreateSingletonPlayer();
          const srcHolder = slide.querySelector('.slide-audio');
          if (!srcHolder) return player;
    
          const nextSrc = (srcHolder.dataset && srcHolder.dataset.src) ? srcHolder.dataset.src : srcHolder.src;
          if (nextSrc && player.src !== nextSrc) {
            try { player.pause(); } catch {}
            player.src = nextSrc;
            player.preload = 'auto';
            await wmWhenCanPlay(player);
          }
          WM_OWNER.slide = slide;
          // Update button state to "pause" only if player is actually playing later.
          // No auto-play on scrub begin; we just prep the source so duration is known.
        }
        return WM_PLAYER || wmCreateSingletonPlayer();
      }
    
      function setSwiperLocked(locked) {
        if (swiper) swiper.allowTouchMove = !locked;
      }
    
      async function onPointerDown(e) {
        // Only react to primary pointer
        if (e.pointerType && e.isPrimary === false) return;
    
        scrubbing = true;
        setSwiperLocked(true);
    
        // Capture pointer so moves stay on this element
        try { barWrapper.setPointerCapture(e.pointerId); hadCapture = true; } catch {}
    
        e.preventDefault();
        e.stopPropagation();
    
        // Prepare player for this slide (so we can seek even if it wasn't the owner)
        const player = await ensurePlayerForThisSlide();
    
        // Initial seek
        const percent = posToPercent(e.clientX);
        if (player?.duration) {
          player.currentTime = percent * player.duration;
        }
    
        // Update UI immediately
        if (filled) filled.style.width = `${percent * 100}%`;
        if (dot) dot.style.left = `${percent * 100}%`;
      }
    
      function onPointerMove(e) {
        if (!scrubbing) return;
        e.preventDefault();
        e.stopPropagation();
    
        const player = WM_PLAYER;
        const percent = posToPercent(e.clientX);
    
        if (player?.duration) {
          player.currentTime = percent * player.duration;
        }
        if (filled) filled.style.width = `${percent * 100}%`;
        if (dot) dot.style.left = `${percent * 100}%`;
      }
    
      function onPointerUp(e) {
        if (!scrubbing) return;
        scrubbing = false;
    
        if (hadCapture) {
          try { barWrapper.releasePointerCapture(e.pointerId); } catch {}
          hadCapture = false;
        }
    
        // Re-enable Swiper after a tick so inertia on the scrub doesn't trigger a slide
        setTimeout(() => setSwiperLocked(false), 30);
    
        e.preventDefault();
        e.stopPropagation();
    
        // Optional: if the player was paused before scrubbing, keep it paused.
        // If you prefer scrub-to-play, you can start playback here:
        // if (WM_PLAYER?.paused) wmSafePlaySlide(slide, { unmute: true });
      }
    
      barWrapper.addEventListener('pointerdown', onPointerDown);
      window.addEventListener('pointermove', onPointerMove, { passive: false });
      window.addEventListener('pointerup', onPointerUp, { passive: false });
      window.addEventListener('pointercancel', onPointerUp, { passive: false });
    
      // Fallback for browsers without Pointer Events (very old Safari):
      // Use touchstart/move/end to do the same thing.
      function touchClientX(t) { return (t && (t.clientX || t.pageX)) || 0; }
    
      function onTouchStart(ev){
        if (scrubbing) return;
        scrubbing = true;
        setSwiperLocked(true);
        ev.preventDefault(); ev.stopPropagation();
        ensurePlayerForThisSlide().then(player => {
          const percent = posToPercent(touchClientX(ev.touches[0]));
          if (player?.duration) player.currentTime = percent * player.duration;
          if (filled) filled.style.width = `${percent * 100}%`;
          if (dot) dot.style.left = `${percent * 100}%`;
        });
      }
      function onTouchMove(ev){
        if (!scrubbing) return;
        ev.preventDefault(); ev.stopPropagation();
        const player = WM_PLAYER;
        const percent = posToPercent(touchClientX(ev.touches[0]));
        if (player?.duration) player.currentTime = percent * player.duration;
        if (filled) filled.style.width = `${percent * 100}%`;
        if (dot) dot.style.left = `${percent * 100}%`;
      }
      function onTouchEnd(ev){
        if (!scrubbing) return;
        scrubbing = false;
        setTimeout(() => setSwiperLocked(false), 30);
        ev.preventDefault(); ev.stopPropagation();
      }
    
      // Attach only if Pointer Events aren’t supported
      if (!('PointerEvent' in window)) {
        barWrapper.addEventListener('touchstart', onTouchStart, { passive: false });
        window.addEventListener('touchmove', onTouchMove, { passive: false });
        window.addEventListener('touchend', onTouchEnd, { passive: false });
        window.addEventListener('touchcancel', onTouchEnd, { passive: false });
      }
    })();
    
    
      const manualResetFade = () => {
      WM_MANUAL_INTERACTION = true;
      resetFade();
      setTimeout(() => { WM_MANUAL_INTERACTION = false; }, 0);
    };
    
    // Tap = toggle controls
    const toggleControls = () => {
      wmToggleControlsForSlide(slide);
    };
    
    // Movement = just show controls (existing behaviour)
    const showControls = () => {
      resetFade();
    };
    
    // Desktop hover/move: show controls (unchanged)
    slide.addEventListener('mousemove', resetFade);
    
    // Mobile + desktop tap: toggle controls (capture = reliable even when overlay children are clicked)
    slide.addEventListener('pointerdown', wmOnPointerDownForToggle, { capture: true, passive: true });
    slide.addEventListener('pointermove', wmOnPointerMoveForToggle, { capture: true, passive: true });
    slide.addEventListener('pointerup', wmOnPointerUpForToggle, { capture: true, passive: true });
    
    // Fallback for very old Safari (no PointerEvent) — keep behaviour reasonable
    if (!('PointerEvent' in window)) {
      cover?.addEventListener('click', () => wmToggleControlsForSlide(slide));
      cover?.addEventListener('touchend', () => wmToggleControlsForSlide(slide), { passive: true });
    }
    
    
    
    
        
      }
    
      function initializeAudioControlsForProduct(productSlide) {
        const carousel = productSlide.querySelector('.audio-player-carousel');
        if (!carousel) return;
    
        const slides = carousel.querySelectorAll('.audio-player-slide');
        slides.forEach(slide => initializeAudioControlsForSlide(slide));
    
        // --- Swiper awareness: ensure active track owns the player after a horizontal swipe
        if (!carousel.swiperInstance) return;
        const swiper = carousel.swiperInstance;
        const getSlideEl = (idx) => swiper.slides[idx]?.querySelector('.audio-player-slide') || swiper.slides[idx];
    
        // initial prefetch neighbors
        wmPrefetchSlideNeighbors(carousel, swiper.activeIndex);
    
        swiper.on('slideChangeTransitionStart', () => {
          const current = WM_OWNER.slide;
          // Pause only if the current owner is inside this carousel
          if (current && current.closest('.audio-player-carousel') === carousel) wmPauseSlide(current);
        });
    
        swiper.on('slideChangeTransitionEnd', async () => {
          const activeIdx = swiper.activeIndex;
          const activeSlide = getSlideEl(activeIdx) || carousel.querySelector('.swiper-slide-active.audio-player-slide') || carousel.querySelector('.swiper-slide-active');
         if (!activeSlide) return;
    
    wmShowControlsForSlide(activeSlide);

    const buttons = carousel.querySelectorAll('.play-pause-button');
    buttons.forEach(btn => setButtonToPlay(btn));
    const activeBtn = activeSlide.querySelector('.play-pause-button');

    if (!WM_MEDIA_UNLOCKED) {
      setButtonToPlay(activeBtn);
      return;
    }

    setButtonToPause(activeBtn);

    await wmSafePlaySlide(activeSlide, { unmute: true });

    if (!WM_MEDIA_UNLOCKED || (WM_PLAYER && WM_PLAYER.paused)) {
      setButtonToPlay(activeBtn);
    }
    
    
          // prefetch neighbours to avoid stalls
          wmPrefetchSlideNeighbors(carousel, activeIdx);
        });
      }
    
      function initializeAudioControls() {
        const productSlides = container.querySelectorAll('.product-slide');
        productSlides.forEach(slide => initializeAudioControlsForProduct(slide));
      }
    
      function initializeSwiperForSlides(slides) {
      slides.forEach(productSlide => {
        const carousel = productSlide.querySelector('.audio-player-carousel');
        if (!carousel || carousel.swiperInstance) return;
    
        // Count slides robustly (works whether your snippet wraps with .swiper-slide or not)
        const slideCount =
          carousel.querySelectorAll('.swiper-wrapper > .swiper-slide').length ||
          carousel.querySelectorAll('.audio-player-slide').length ||
          0;
    
        const single = slideCount <= 1;
        if (single) carousel.classList.add('single-track');
    
        const swiper = new Swiper(carousel, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
    roundLengths: true,
    
          allowTouchMove: !single,   // no swiping when only one
          // only wire nav/pagination when there’s more than one
          navigation: single ? {} : {
            nextEl: carousel.querySelector('.swiper-button-next'),
            prevEl: carousel.querySelector('.swiper-button-prev'),
          },
          pagination: single ? false : {
            el: carousel.querySelector('.swiper-pagination'),
            clickable: true
          }
        });
    
        carousel.swiperInstance = swiper;
        requestAnimationFrame(() => swiper.update());
    
    
    
        // WM: start controls hidden so we can fade them in (no autoplay impact)
        carousel.classList.add('hide-controls');
      });
    }
    
    
    
      // AJAX Add to Cart (unchanged)
      document.addEventListener('submit', function(e) {
        if (e.target.matches('.ajax-cart-form')) {
          e.preventDefault();
          const form = e.target;
  const button = form.querySelector('.add-to-cart');
  if (button && button.disabled) return;
  
  const formData = new FormData(form);
          const cartText = button?.querySelector('.cart-text');
          const loadingText = button?.querySelector('.cart-loading');
          if (cartText && loadingText) { cartText.style.display = 'none'; loadingText.style.display = 'inline'; }
    
          fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
            .then(res => { if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`); return res.json(); })
            .then(() => {
              if (cartText && loadingText) { cartText.textContent = 'Added'; loadingText.style.display = 'none'; cartText.style.display = 'inline'; }
              const carousel = form.closest('.audio-player-carousel');
              if (carousel) {
                carousel.querySelectorAll('.add-to-cart').forEach(btn => {
                  const txt = btn.querySelector('.cart-text');
                  const load = btn.querySelector('.cart-loading');
                  if (txt) txt.textContent = 'Added';
                  if (load) load.style.display = 'none';
                  if (txt) txt.style.display = 'inline';
                });
              }
              fetch('/cart.js').then(res => res.json()).then(cart => {
                const count = cart.item_count;
                const cartIcon = document.querySelector('#CartButton [x-text="$store.cart_count.count"]');
                if (cartIcon) {
                  cartIcon.textContent = count;
                  cartIcon.style.display = count > 0 ? 'flex' : 'none';
                  cartIcon.classList.add('cart-updated');
                  setTimeout(() => cartIcon.classList.remove('cart-updated'), 800);
                }
              });
            })
            .catch(err => {
              if (cartText && loadingText) { cartText.textContent = 'Error'; loadingText.style.display = 'none'; cartText.style.display = 'inline'; }
              console.error('Error adding to cart:', err);
            });
        }
      });

      document.addEventListener('click', function(e) {
        const notifyButton = e.target.closest('.wm-notify-me-button');
        if (!notifyButton) return;

        e.preventDefault();
        e.stopPropagation();

        wmHandleNotifyMeClick(notifyButton);
      }, true);

      document.addEventListener('click', function(e) {
        const wishlistButton = e.target.closest('#verticalSwipeContainer .wk-button');
        if (!wishlistButton) return;

        const wasActive = wmWishlistButtonIsActive(wishlistButton);
        if (!wmCustomerIsLoggedIn() && !wasActive) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          wmSavePendingWishlistAdd(wishlistButton);
          wmPromptWishlistLoginIfNeeded({
            title: 'Save your wishlist',
            body: 'Sign in or create an account to save your wishlist and access it whenever you come back.'
          });
          return;
        }

        wmScheduleWishlistCounterRefresh();
      }, true);
    
      // Mobile add-to-cart touch handler
      document.addEventListener('touchend', function(e) {
    const btn = e.target.closest('.add-to-cart');
    if (!btn || btn.disabled) return;
  
    const form = btn.closest('.ajax-cart-form');
    if (form) {
      e.stopPropagation();
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  }, { passive: true });
    
      // Pause when tab hidden (mobile)
      document.addEventListener('visibilitychange', function () {
        if (window.innerWidth <= 767 && document.hidden) {
          if (WM_PLAYER && !WM_PLAYER.paused) {
            try { WM_PLAYER.pause(); } catch {}
            if (WM_OWNER.slide) {
              const btn = WM_OWNER.slide.querySelector('.play-pause-button');
              setButtonToPlay(btn);
            }
          }
        }
      });
    
      async function loadNextPageNormal() {
      if (isLoading) return;
    
      if (currentPage >= totalPages) {
        if (endMessage) endMessage.style.display = 'block';
        return;
      }
    
    
      isLoading = true;
      loadingIndicator.style.display = 'block';
    
      const nextPage = currentPage + 1;
    
      // Preserve current filters (artist, label, sort_by, etc.)
      const params = new URLSearchParams(window.location.search);
      params.set('page', nextPage);
      params.set('view', 'ajax');
    
      // If no sort_by in current URL, fall back to current sort
      if (!params.has('sort_by') && sortBy) params.set('sort_by', sortBy);
    
      const url = `${window.location.pathname}?${params.toString()}`;
    
      try {
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Failed to load next page');
    
        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
    
        const newSlides = tempDiv.querySelectorAll('.product-slide');
    newSlides.forEach(slide => {
      container.appendChild(slide);
      wmApplyWishlistStockState(slide);
      if (WM_PRODUCT_IO) WM_PRODUCT_IO.observe(slide);
    });
    
        // Title marquee for newly appended products
        wmInitTitleMarquees(container);
        wmObserveNewMarqueeCards(Array.from(newSlides));
    
        currentPage = nextPage;
        container.dataset.currentPage = currentPage;
    
        initializeSwiperForSlides(Array.from(newSlides));
        newSlides.forEach(slide => initializeAudioControlsForProduct(slide));
        wmMaybeInsertSpecialCards(container);
    
    
        // enhance appended covers + JIT audio to new slides
        Array.from(newSlides).forEach((ps, idx) => {
          const cover = ps.querySelector('.audio-cover');
          wmEnhanceCoverImage(cover, idx);
        });
        wmHydrateSlidesNearViewport(container);
        
        wmSafariLazyImageFix(container);
    
    
        if (endMessage) endMessage.style.display = currentPage >= totalPages ? 'block' : 'none';
      } catch (error) {
        console.error('Error loading more products:', error);
      } finally {
        isLoading = false;
        loadingIndicator.style.display = 'none';
      }
    }
    async function wmRestoreReturnPositionIfNeeded() {
      if (!WM_PENDING_RETURN || !container) {
        await wmCompletePendingWishlistAdd();
        return;
      }
    
      WM_RETURN_RESTORE_ACTIVE = true;
      try {
        const saved = WM_PENDING_RETURN;
        WM_PENDING_RETURN = null;
        const activeSort = (() => {
          try {
            const params = new URLSearchParams(window.location.search);
            return params.get('sort_by') || container?.dataset?.sortBy || 'created-descending';
          } catch (e) {
            return container?.dataset?.sortBy || 'created-descending';
          }
        })();
        const isNewestReturn = activeSort === 'created-descending';

        console.log('[WM RETURN] start', {
          href: window.location.href,
          activeSort,
          isNewestReturn,
          saved,
          existingSlides: container.querySelectorAll('.product-slide[data-product-handle]').length,
          existingScrollTop: container.scrollTop
        });

        await wmWaitForCollectionIndex();

        const buildReturnActiveCollectionIndex = () => {
          const full = Array.isArray(window.WM_COLLECTION_INDEX) ? window.WM_COLLECTION_INDEX : [];

          let showPreorders = true;
          try {
            const savedPreorderSetting = localStorage.getItem('wm_show_preorders');
            if (savedPreorderSetting === '0') showPreorders = false;
          } catch (e) {}

          const filtered = showPreorders
            ? full.slice()
            : full.filter((item) => !wmIsPreorderIndexItem(item));

          const parseIndexDate = (value) => {
            if (!value) return 0;
            if (typeof value === 'string' || value instanceof String) {
              const parsed = new Date(value).getTime();
              return Number.isFinite(parsed) ? parsed : 0;
            }
            if (Array.isArray(value) && value.length >= 6) {
              const seconds = Number(value[0]) || 0;
              const minutes = Number(value[1]) || 0;
              const hours = Number(value[2]) || 0;
              const day = Number(value[3]) || 1;
              const month = (Number(value[4]) || 1) - 1;
              const year = Number(value[5]) || 1970;
              return Date.UTC(year, month, day, hours, minutes, seconds);
            }
            if (typeof value === 'number') {
              return Number.isFinite(value) ? value : 0;
            }
            return 0;
          };

          if (activeSort === 'created-descending') {
            filtered.sort((a, b) => {
              const timeA = parseIndexDate(a?.stock_movement_at || a?.created_at || null);
              const timeB = parseIndexDate(b?.stock_movement_at || b?.created_at || null);
              return timeB - timeA;
            });
          }

          if (wmIsShuffleMode()) {
            for (let i = filtered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [filtered[i], filtered[j]] = [filtered[j], filtered[i]];
            }
          }

          return filtered;
        };

        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('wm_return');
          history.replaceState({}, '', url.toString());
        } catch (e) {}

        const scrollToTop = (top) => {
          requestAnimationFrame(() => {
            container.scrollTop = top;
            setTimeout(() => { container.scrollTop = top; }, 60);
            setTimeout(() => { container.scrollTop = top; }, 180);
          });
        };

        if (!isNewestReturn) {
          const tryFindExisting = () => {
            if (!saved.productHandle) return null;
            return container.querySelector(
              `.product-slide[data-product-handle="${CSS.escape(saved.productHandle)}"]`
            );
          };

          let target = tryFindExisting();

          console.log('[WM RETURN] non-newest initial', {
            targetFound: !!target,
            productHandle: saved.productHandle,
            scrollTop: saved.scrollTop,
            containerScrollHeight: container.scrollHeight,
            clientHeight: container.clientHeight,
            cursor: window.WM_INDEX_CURSOR
          });

          while (!target && saved.scrollTop != null && container.scrollHeight < (saved.scrollTop + container.clientHeight)) {
            const beforeHeight = container.scrollHeight;
            const beforeCursor = window.WM_INDEX_CURSOR;
            await loadNextPage();
            target = tryFindExisting();
            console.log('[WM RETURN] non-newest loadNextPage', {
              beforeHeight,
              afterHeight: container.scrollHeight,
              beforeCursor,
              afterCursor: window.WM_INDEX_CURSOR,
              targetFound: !!target
            });
            if (container.scrollHeight === beforeHeight && window.WM_INDEX_CURSOR === beforeCursor) break;
          }

          if (target) {
            console.log('[WM RETURN] non-newest target', {
              productHandle: saved.productHandle,
              targetTop: target.offsetTop,
              offsetInSlide: saved.offsetInSlide
            });
            scrollToTop(target.offsetTop + (saved.offsetInSlide || 0));
            sessionStorage.removeItem('wm_feed_return');
            sessionStorage.removeItem('wm_auth_return_pending');
            return;
          }

          if (saved.scrollTop != null) {
            console.log('[WM RETURN] non-newest fallback scrollTop', {
              scrollTop: saved.scrollTop
            });
            scrollToTop(saved.scrollTop);
            sessionStorage.removeItem('wm_feed_return');
            sessionStorage.removeItem('wm_auth_return_pending');
            return;
          }
        }

        window.WM_ACTIVE_COLLECTION_INDEX = buildReturnActiveCollectionIndex();
        console.log('[WM RETURN] newest source built', {
          sourceLength: Array.isArray(window.WM_ACTIVE_COLLECTION_INDEX) ? window.WM_ACTIVE_COLLECTION_INDEX.length : 0
        });
        container.querySelectorAll('.product-slide').forEach((el) => el.remove());
        window.WM_INDEX_CURSOR = 0;
        if (endMessage) endMessage.style.display = 'none';
        await loadNextPage();

        const source = Array.isArray(window.WM_ACTIVE_COLLECTION_INDEX) ? window.WM_ACTIVE_COLLECTION_INDEX : [];
        const indexedHandle =
          saved.sourceIndex != null &&
          saved.sourceIndex >= 0 &&
          saved.sourceIndex < source.length
            ? (source[saved.sourceIndex]?.handle || source[saved.sourceIndex]?.product_handle || null)
            : null;
        const targetHandle = saved.productHandle || indexedHandle;

        console.log('[WM RETURN] newest rebuilt', {
          sourceLength: source.length,
          cursor: window.WM_INDEX_CURSOR,
          savedSourceIndex: saved.sourceIndex,
          indexedHandle,
          targetHandle,
          existingSlides: container.querySelectorAll('.product-slide[data-product-handle]').length
        });

        if (
          saved.sourceIndex != null &&
          saved.sourceIndex >= 0 &&
          window.WM_INDEX_CURSOR <= saved.sourceIndex
        ) {
          while (
            window.WM_INDEX_CURSOR <= saved.sourceIndex &&
            window.WM_INDEX_CURSOR < source.length
          ) {
            await loadNextPage();
            console.log('[WM RETURN] newest loadToIndex', {
              cursor: window.WM_INDEX_CURSOR,
              targetIndex: saved.sourceIndex
            });
          }
        }

        let target = targetHandle
          ? container.querySelector(`.product-slide[data-product-handle="${CSS.escape(targetHandle)}"]`)
          : null;

        while (!target && targetHandle && window.WM_INDEX_CURSOR < source.length) {
          await loadNextPage();
          target = container.querySelector(`.product-slide[data-product-handle="${CSS.escape(targetHandle)}"]`);
          console.log('[WM RETURN] newest loadToHandle', {
            cursor: window.WM_INDEX_CURSOR,
            targetHandle,
            targetFound: !!target
          });
        }

        if (!target && saved.sourceIndex != null && saved.sourceIndex >= 0) {
          const productSlides = Array.from(
            container.querySelectorAll('.product-slide[data-product-handle]')
          ).filter((slide) => !wmIsSpecialCard(slide));
          target = productSlides[saved.sourceIndex] || null;
          console.log('[WM RETURN] newest fallback index', {
            productSlides: productSlides.length,
            savedSourceIndex: saved.sourceIndex,
            targetFound: !!target
          });
        }

        if (target) {
          console.log('[WM RETURN] newest target', {
            targetHandle,
            targetTop: target.offsetTop,
            offsetInSlide: saved.offsetInSlide,
            finalCursor: window.WM_INDEX_CURSOR
          });
          scrollToTop(target.offsetTop + (saved.offsetInSlide || 0));
          sessionStorage.removeItem('wm_feed_return');
          sessionStorage.removeItem('wm_auth_return_pending');
          return;
        }

        if (saved.scrollTop != null) {
          while (
            container.scrollHeight < (saved.scrollTop + container.clientHeight) &&
            window.WM_INDEX_CURSOR < source.length
          ) {
            await loadNextPage();
            console.log('[WM RETURN] newest fallback scrollTop load', {
              cursor: window.WM_INDEX_CURSOR,
              scrollHeight: container.scrollHeight,
              requiredHeight: saved.scrollTop + container.clientHeight
            });
          }

          console.log('[WM RETURN] newest fallback scrollTop', {
            scrollTop: saved.scrollTop,
            finalCursor: window.WM_INDEX_CURSOR
          });
          scrollToTop(saved.scrollTop);
          sessionStorage.removeItem('wm_feed_return');
          sessionStorage.removeItem('wm_auth_return_pending');
        }
      } catch (e) {
        console.error('WM return restore failed', e);
      } finally {
        WM_RETURN_RESTORE_ACTIVE = false;
        try {
          await wmCompletePendingWishlistAdd();
        } catch (e) {
          console.warn('WM pending wishlist add failed', e);
        }
      }
    }
    
    async function wmWaitForCollectionIndex(){
    if (window.WM_COLLECTION_INDEX_READY) {
      try {
        await window.WM_COLLECTION_INDEX_READY;
      } catch(e) {
        console.error('WM_COLLECTION_INDEX_READY failed', e);
      }
    }
  }
  
      // infinite scroll
      let scrollThrottle = false;
      container.addEventListener('scroll', () => {
    if (scrollThrottle) return;
    scrollThrottle = true;
  
    setTimeout(async () => {
      scrollThrottle = false;
      if (isLoading || currentPage >= totalPages) return;
  
      const scrollPos = container.scrollTop + container.clientHeight;
      const triggerPoint = container.scrollHeight - 1400;
  
      if (scrollPos >= triggerPoint) {
        await wmWaitForCollectionIndex();
  
        if (wmIsShuffleMode() && !wmShouldPrioritizePinnedHandle()) {
          // stop requesting once we’ve exhausted the shuffled pool
          if (WM_HANDLES_DONE && WM_HANDLE_CURSOR >= WM_HANDLE_POOL.length) {
            if (endMessage) endMessage.style.display = 'block';
            return;
          }
          wmLoadRandomBatch(container);
        } else {
          loadNextPage();
        }
      }
    }, 150);
  });
    
      function initializeAllExistingSlides() {
        const initialSlides = container.querySelectorAll('.product-slide');
        initialSlides.forEach(slide => wmApplyWishlistStockState(slide));
        initializeSwiperForSlides(Array.from(initialSlides));
        initializeAudioControls();
      }
    
      function mostVisibleProductSlide(){
      const cont = document.getElementById('verticalSwipeContainer');
      if (!cont) return null;
    
      const productSlides = Array.from(cont.querySelectorAll('.product-slide'));
      if (!productSlides.length) return null;
    
      // Choose the product whose top is closest to the container's scrollTop
      const y = cont.scrollTop + 8;
      let best = productSlides[0];
      let bestDist = Infinity;
    
      for (const ps of productSlides){
        const d = Math.abs(ps.offsetTop - y);
        if (d < bestDist){
          bestDist = d;
          best = ps;
        }
      }
      return best;
    }
    
    // WM: hard “start playback NOW” helper (used by overlay dismiss + audioUnlocked)
    async function kickVisibleSlide(){
      const ps = mostVisibleProductSlide();
      if (!ps) return;
    
      const audioSlide =
        (typeof wmGetActiveAudioSlideFromProduct === 'function' && wmGetActiveAudioSlideFromProduct(ps)) ||
        ps.querySelector('.audio-player-slide');
    
      if (!audioSlide) return;
    
      // If still not unlocked, don't attempt (iOS will block)
      if (!WM_MEDIA_UNLOCKED) return;
    
      // UI: reveal controls + set icons immediately
      wmShowControlsForSlide(audioSlide);
    
      ps.querySelectorAll('.play-pause-button').forEach(b => setButtonToPlay(b));
      const btn = audioSlide.querySelector('.play-pause-button');
      setButtonToPause(btn);
    
      await wmSafePlaySlide(audioSlide, { unmute: true });
    
      // If play failed, revert icon
      if (!WM_MEDIA_UNLOCKED || (WM_PLAYER && WM_PLAYER.paused)) {
        setButtonToPlay(btn);
        return;
      }
    
      WM_PENDING_AUTOBOOT = false;
    }
    
      // WM: When overlay is skipped, show Play button on the first visible product (no autoplay)
    function wmPromptPlayOnFirstVisible(){
      const container = document.getElementById('verticalSwipeContainer');
      if (!container) return;
    
      const productSlides = Array.from(container.querySelectorAll('.product-slide'));
      if (!productSlides.length) return;
    
      // Pick the product closest to the top of the feed container
      const y = container.scrollTop;
      let best = productSlides[0];
      let bestDist = Infinity;
    
      for (const ps of productSlides){
        const d = Math.abs(ps.offsetTop - y);
        if (d < bestDist){
          bestDist = d;
          best = ps;
        }
      }
    
      // Get the active horizontal audio slide for that product
      const audioSlide =
        (typeof wmGetActiveAudioSlideFromProduct === 'function' && wmGetActiveAudioSlideFromProduct(best)) ||
        best.querySelector('.audio-player-slide');
    
      if (!audioSlide) return;
    
      const carousel = audioSlide.closest('.audio-player-carousel');
      if (carousel){
        // Ensure controls are visible and STAY visible
        clearTimeout(carousel.hideControlsTimer);
        carousel.classList.remove('hide-controls');
      }
    
      // Force all buttons to Play, especially the active one
      best.querySelectorAll('.play-pause-button').forEach(b => setButtonToPlay(b));
      setButtonToPlay(audioSlide.querySelector('.play-pause-button'));
    }
    
    
      /* ================================
       WM: PRODUCT-level autoplay (iOS Safari safe)
       - Observe .product-slide within #verticalSwipeContainer (rooted IO)
       - Autoplay the active horizontal track inside the most-visible product
    ================================ */
    let WM_ACTIVE_PRODUCT = null;
  let WM_MANUAL_INTERACTION = false;
  let wmAutoTimer = null;
  let wmAutoToken = 0;
  let WM_PRODUCT_IO = null;
  let WM_SUPPRESS_AUTOPLAY = false;
    
    function wmGetActiveAudioSlideFromProduct(productSlide){
      const carousel = productSlide?.querySelector('.audio-player-carousel');
      if (!carousel) return null;
    
      const swiper = carousel.swiperInstance;
      if (swiper && swiper.slides && swiper.slides.length){
        const s = swiper.slides[swiper.activeIndex];
        return s?.querySelector('.audio-player-slide') || s;
      }
    
      // Fallback if swiper isn't ready for some reason
      return carousel.querySelector('.audio-player-slide');
    }
    
    function wmIsSpecialCard(productSlide){
      return !!productSlide && (
        productSlide.classList.contains('wm-special-card') ||
        productSlide.dataset.wmSpecial === '1'
      );
    }
    
    // If the most-visible slide is a special card, stop audio immediately
    function wmPauseIfSpecialIsMostVisible(){
      const ps = mostVisibleProductSlide?.();
      if (!ps) return false;
    
      if (wmIsSpecialCard(ps)) {
        if (WM_OWNER.slide) {
          wmPauseSlide(WM_OWNER.slide);
          const oldBtn = WM_OWNER.slide.querySelector('.play-pause-button');
          setButtonToPlay(oldBtn);
        }
        WM_ACTIVE_PRODUCT = ps; // prevent re-autoplay loops on the previous slide
        return true;
      }
      return false;
    }
    
    
    async function wmAutoplayProduct(productSlide){
    if (!productSlide) return;
    if (WM_SUPPRESS_AUTOPLAY) return;
    if (!WM_AUTOBOOT_ALLOWED) return;
  
    const container = document.getElementById('verticalSwipeContainer');
    if (window.WM_FEED_SOURCE === 'wishlist' && container) {
      const remainingSlides = container.querySelectorAll('.product-slide');
      if (!remainingSlides.length) return;
    }
    
      // Always pause the previous product when the active product changes
      // (even if audio isn't unlocked yet)
      if (WM_OWNER.slide && WM_OWNER.slide.closest('.product-slide') !== productSlide){
        wmPauseSlide(WM_OWNER.slide);
        const oldBtn = WM_OWNER.slide.querySelector('.play-pause-button');
        setButtonToPlay(oldBtn);
      }
    
      // If audio not unlocked yet, stop here (prevents “no pause” behaviour)
      if (!WM_MEDIA_UNLOCKED) return;
    
    
      const token = ++wmAutoToken;
    
      // FAST + SAFE: tiny debounce (≈1 frame) using setTimeout to coalesce iOS IO bursts
      clearTimeout(wmAutoTimer);
      wmAutoTimer = setTimeout(async () => {
        if (token !== wmAutoToken) return;
    
        const audioSlide = wmGetActiveAudioSlideFromProduct(productSlide);
        if (!audioSlide) return;
    
        // Show overlay immediately (matches old behaviour: controls appear as card becomes active)
        wmShowControlsForSlide(audioSlide);
    
        // If already owning + playing, do nothing
        if (WM_OWNER.slide === audioSlide && WM_PLAYER && !WM_PLAYER.paused) return;
    
        // If a different product currently owns playback, pause it
        if (WM_OWNER.slide && WM_OWNER.slide.closest('.product-slide') !== productSlide){
          wmPauseSlide(WM_OWNER.slide);
          const oldBtn = WM_OWNER.slide.querySelector('.play-pause-button');
          setButtonToPlay(oldBtn);
        }
    
        // Update button states inside this product immediately (prevents circle-before-icon lag on mobile)
        productSlide.querySelectorAll('.play-pause-button').forEach(b => setButtonToPlay(b));
        const activeBtn = audioSlide.querySelector('.play-pause-button');
        setButtonToPause(activeBtn);
    
        await wmSafePlaySlide(audioSlide, { unmute: true });
    
        // If playback didn't actually start, revert the icon
        if (!WM_MEDIA_UNLOCKED || (WM_PLAYER && WM_PLAYER.paused)) {
          setButtonToPlay(activeBtn);
        }
      }, 0);
    }
    
    
    
    function wmSetupProductAutoplayObserver(){
      if (!container) return;
      if (WM_PRODUCT_IO) return;
    
      WM_PRODUCT_IO = new IntersectionObserver(entries => {
      let best = null;
      let bestRatio = 0;
    
      for (const e of entries){
        if (!e.isIntersecting) continue;
        if (e.intersectionRatio > bestRatio){
          bestRatio = e.intersectionRatio;
          best = e.target;
        }
      }
    
      if (!best || bestRatio < 0.55) return;
    
      /* ===============================
         SPECIAL CARD: pause immediately
      =============================== */
      if (best.classList.contains('wm-special-card') || best.dataset.wmSpecial === '1'){
        if (WM_OWNER.slide){
          wmPauseSlide(WM_OWNER.slide);
          const oldBtn = WM_OWNER.slide.querySelector('.play-pause-button');
          setButtonToPlay(oldBtn);
        }
        WM_ACTIVE_PRODUCT = best;
        return;
      }
    
      /* ===============================
         NORMAL PRODUCT: autoplay
      =============================== */
      if (best !== WM_ACTIVE_PRODUCT){
        WM_ACTIVE_PRODUCT = best;
        wmAutoplayProduct(best);
      }
    
    }, {
      root: container,
      threshold: [0.25, 0.55, 0.75]
    });
    
    
      container.querySelectorAll('.product-slide').forEach(ps => WM_PRODUCT_IO.observe(ps));
    }
    
    
      // Retry play after momentum scrolling settles (use the FEED container, not window)
    let contScrollTimer;
    container.addEventListener('scroll', () => {
      clearTimeout(contScrollTimer);
      contScrollTimer = setTimeout(() => {
        if (!WM_AUTOBOOT_ALLOWED) return;
        // 1) If special card is most visible, pause and bail
        if (wmPauseIfSpecialIsMostVisible()) return;
    
        // 2) Otherwise continue normal behaviour
        if (WM_ACTIVE_PRODUCT) wmAutoplayProduct(WM_ACTIVE_PRODUCT);
      }, 140);
    }, { passive:true });
    
    async function wmWaitForCollectionIndex(){
    if (window.WM_COLLECTION_INDEX_READY) {
      try {
        await window.WM_COLLECTION_INDEX_READY;
      } catch (e) {
        console.error('WM_COLLECTION_INDEX_READY failed', e);
      }
    }
  }
    
    // IMPORTANT: create observer FIRST so shuffle-added slides can be observed immediately
    wmSetupProductAutoplayObserver();
    
    if (wmIsShuffleMode() && !wmShouldPrioritizePinnedHandle()) {
      wmInitShuffle(container); // can remain non-awaited
    } else {
      initializeAllExistingSlides();
      wmSafariLazyImageFix(container);
    
    
      // If overlay is not present, show Play prompt on slide 1
      if (!WM_AUTOBOOT_ALLOWED && !overlay) {
        wmPromptPlayOnFirstVisible();
      } else if (WM_IS_APP) {
        wmUnlockAudioOnce().then(() => {
          if (WM_MEDIA_UNLOCKED) kickVisibleSlide();
        }).catch(() => {
          wmPromptPlayOnFirstVisible();
        });
      }
      wmMaybeInsertSpecialCards(container);
    
    }
    
    
    
    
    
    
      
    
      wmInitTitleMarquees(container);
  wmSetupAutoTitleMarquee();
  
  // Wait for JSON index, then restore saved position if needed
  (async function(){
    await wmWaitForCollectionIndex();
    await wmRestoreReturnPositionIfNeeded();
  })();
    
    
    
      // enhance existing covers + JIT audio
      (function enhanceExistingCovers(){
        const covers = Array.from(document.querySelectorAll('.audio-cover'));
        covers.forEach((img, i) => wmEnhanceCoverImage(img, i));
      })();
      wmHydrateSlidesNearViewport(container);
    
      // After unlock, immediately play visible slide
       window.addEventListener('audioUnlocked', () => {
        // Only autoboot when user explicitly allowed it (overlay click OR play press)
        if (!WM_AUTOBOOT_ALLOWED) return;
    
        if (!wmIsShuffleMode() || !WM_SHUFFLE_BOOTING) kickVisibleSlide();
      }, { once:true });
    
    
    
      // Keyboard nav (desktop)
      if (window.innerWidth > 767) {
        document.addEventListener('keydown', function (e) {
          const slides = Array.from(document.querySelectorAll('.product-slide'));
          if (!slides.length) return;
          let activeSlide = slides[0], maxVisible = 0;
          slides.forEach(slide => {
            const rect = slide.getBoundingClientRect();
            const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);
            if (visibleHeight > maxVisible) { maxVisible = visibleHeight; activeSlide = slide; }
          });
          const carousel = activeSlide.querySelector('.audio-player-carousel');
          const swiper = carousel?.swiperInstance;
          const sortBarHeight = document.querySelector('.sorting-bar')?.offsetHeight || 0;
          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const gapOffset = 10;
          function scrollToSlideWithOffset(slide) {
            const targetPos = slide.offsetTop - headerHeight - sortBarHeight - gapOffset;
            const cont = document.getElementById('verticalSwipeContainer');
            cont.scrollTo({ top: targetPos, behavior: 'smooth' });
          }
          switch (e.key) {
            case 'ArrowLeft': swiper?.slidePrev(); break;
            case 'ArrowRight': swiper?.slideNext(); break;
            case 'ArrowUp': e.preventDefault(); { const prev = slides[slides.indexOf(activeSlide) - 1]; if (prev) scrollToSlideWithOffset(prev); } break;
            case 'ArrowDown': e.preventDefault(); { const next = slides[slides.indexOf(activeSlide) + 1]; if (next) scrollToSlideWithOffset(next); } break;
          }
        });
      }
      // =======================================================
  // WM JSON-backed feed loader
  // keeps existing calls to loadNextPage() working
  // =======================================================
  window.WM_INDEX_CURSOR = window.WM_INDEX_CURSOR || 0;
  const WM_BATCH_SIZE = 5;
  
  function wmGetCurrentIndexSource(){
    return Array.isArray(window.WM_ACTIVE_COLLECTION_INDEX)
      ? window.WM_ACTIVE_COLLECTION_INDEX
      : (Array.isArray(window.WM_COLLECTION_INDEX) ? window.WM_COLLECTION_INDEX : []);
  }
  
  function wmSyncIndexCursorToDom(){
    const source = wmGetCurrentIndexSource();
    if (!Array.isArray(source) || !source.length || !container) return;
  
    const sourceHandles = new Set(
      source
        .map(item => item && (item.handle || item.product_handle))
        .filter(Boolean)
    );
  
    const domHandles = Array.from(
      container.querySelectorAll('.product-slide[data-product-handle]')
    )
      .map(el => el.dataset.productHandle)
      .filter(handle => handle && sourceHandles.has(handle));
  
    // De-dupe in case the same handle somehow appears twice in DOM
    const uniqueDomHandles = Array.from(new Set(domHandles));
  
    window.WM_INDEX_CURSOR = uniqueDomHandles.length;
  }

  function wmDedupeRenderedProductSlides(preferredHandle = '', preferredNode = null){
    if (!container) return;

    const byHandle = new Map();
    const slides = Array.from(container.querySelectorAll('.product-slide[data-product-handle]'))
      .filter(slide => !slide.classList.contains('wm-special-card') && slide.dataset.wmSpecial !== '1');

    slides.forEach(slide => {
      const handle = slide.getAttribute('data-product-handle') || '';
      if (!handle) return;

      if (!byHandle.has(handle)) byHandle.set(handle, []);
      byHandle.get(handle).push(slide);
    });

    byHandle.forEach((dupes, handle) => {
      if (dupes.length < 2) return;

      const preferred =
        (preferredHandle && handle === preferredHandle && preferredNode && dupes.includes(preferredNode))
          ? preferredNode
          : (dupes.find(slide => slide.getAttribute('data-wm-pinned') === '1') || dupes[0]);

      dupes.forEach(slide => {
        if (slide === preferred) return;

        try { wmDestroyProductSlideRuntime(slide); } catch (e) {}
        slide.remove();
      });
    });
  }
  
  function wmIsPreorderIndexItem(item){
      if (!item) return false;
  
      const tags = Array.isArray(item.tags) ? item.tags.map(t => String(t).toLowerCase()) : [];
      const inventoryQty = Number(item.inventory_quantity ?? item.inventory ?? 0);
      const inventoryPolicy = String(item.inventory_policy ?? '').toLowerCase();
      const available = !!item.available;
  
      return (
        item.is_preorder === true ||
        tags.includes('preorder') ||
        (available && inventoryPolicy === 'continue' && inventoryQty <= 0)
      );
    }

  function wmEnsureFilterPills(root = container){
    if (!root) return;

    const filterSource = root.dataset?.wmFilterSource || '';
    const filterValue = root.dataset?.wmFilterValue || '';
    if (!filterSource || !filterValue) return;

    const current = new URL(window.location.href);
    const clearUrl = current.pathname + (current.searchParams.get('sort_by')
      ? `?sort_by=${encodeURIComponent(current.searchParams.get('sort_by'))}&wm_return=1`
      : '?wm_return=1');

    root.querySelectorAll('.audio-content, .static-cover-wrapper').forEach((target) => {
      if (target.querySelector('.wm-filter-sticker')) return;

      const pill = document.createElement('a');
      pill.className = 'wm-filter-sticker';
      pill.href = clearUrl;
      pill.append(
        document.createTextNode(`${filterSource === 'artist' ? 'Artist:' : 'Label:'} ${filterValue} `)
      );

      const x = document.createElement('span');
      x.className = 'wm-filter-sticker__x';
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '×';
      pill.appendChild(x);

      target.appendChild(pill);
    });
  }
  
  async function wmLoadNextIndexBatch(){
    await wmWaitForCollectionIndex();
  
    wmSyncIndexCursorToDom();
    const source = wmGetCurrentIndexSource();
  
    if (!source.length) {
      if (endMessage) endMessage.style.display = 'block';
      return;
    }
  
    if (window.WM_INDEX_CURSOR >= source.length) {
      if (endMessage) endMessage.style.display = 'block';
      return;
    }
  
    if (isLoading) return;
    isLoading = true;
    if (loadingIndicator) loadingIndicator.style.display = 'block';
  
    try {
      const slice = source.slice(window.WM_INDEX_CURSOR, window.WM_INDEX_CURSOR + WM_BATCH_SIZE);
  
      window.WM_INDEX_CURSOR += slice.length;
  
      const pinnedHandle = wmShouldPrioritizePinnedHandle() ? wmGetPinnedHandleFromUrl() : '';
      const cardChunks = await Promise.all(
    slice.map(async (item) => {
      const handle = item && (item.handle || item.product_handle);
      if (!handle) return { html: '', item };
  
      try {
        if (pinnedHandle && handle === pinnedHandle) {
          const [pinnedSlide, pinnedItem] = await Promise.all([
            wmFetchPinnedSlide(handle),
            wmFetchPinnedProductState(handle)
          ]);

          return {
            html: pinnedSlide ? pinnedSlide.outerHTML : '',
            item: pinnedItem || item
          };
        }

        const ajaxCardUrl = wmBuildAjaxCardUrl(handle);
  
        const res = await fetch(ajaxCardUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
  
        if (!res.ok) {
          console.warn('WM ajax-card fetch failed:', handle, res.status);
          return { html: '', item };
        }
  
        return {
          html: await res.text(),
          item
        };
      } catch (err) {
        console.warn('WM ajax-card fetch error:', handle, err);
        return { html: '', item };
      }
    })
  );
  
      const newSlides = [];
  
      cardChunks.forEach((chunk, idx) => {
        const html = chunk?.html || '';
        if (!html) return;
  
        const doc = new DOMParser().parseFromString(html, 'text/html');
        let slide = doc.querySelector('.product-slide');
        const item = chunk?.item || slice[idx];
  
        if (!slide) {
          const bodyHtml = (doc.body && doc.body.innerHTML ? doc.body.innerHTML : html).trim();
          if (!bodyHtml) return;
  
          const handle = item && (item.handle || item.product_handle);
          const productId = item && (item.id || item.product_id || '');
  
          const wrapper = document.createElement('section');
          wrapper.className = 'product-slide';
  
          if (handle) wrapper.setAttribute('data-product-handle', handle);
          if (productId) wrapper.setAttribute('data-product-id', productId);
          if (Object.prototype.hasOwnProperty.call(item || {}, 'available')) {
            wrapper.setAttribute('data-wm-available', item.available ? '1' : '0');
          }
  
          wrapper.setAttribute('data-wm-preorder', wmIsPreorderIndexItem(item) ? '1' : '0');
  
          const inner = document.createElement('div');
          inner.className = 'product-slide-inner';
          inner.innerHTML = bodyHtml;
  
          wrapper.appendChild(inner);
          slide = wrapper;
        } else {
          const handle = item && (item.handle || item.product_handle);
          const productId = item && (item.id || item.product_id || '');
  
          if (handle && !slide.getAttribute('data-product-handle')) {
            slide.setAttribute('data-product-handle', handle);
          }
          if (productId && !slide.getAttribute('data-product-id')) {
            slide.setAttribute('data-product-id', productId);
          }
          if (Object.prototype.hasOwnProperty.call(item || {}, 'available')) {
            slide.setAttribute('data-wm-available', item.available ? '1' : '0');
          }
          if (!slide.getAttribute('data-wm-preorder')) {
            slide.setAttribute('data-wm-preorder', wmIsPreorderIndexItem(item) ? '1' : '0');
          }
        }

        const handle = item && (item.handle || item.product_handle);
        if (pinnedHandle && handle === pinnedHandle) {
          slide.setAttribute('data-wm-pinned', '1');
        }
  
        container.appendChild(slide);
        if (pinnedHandle && handle === pinnedHandle) {
          wmApplyPinnedStockState(slide, item);
        } else {
          wmApplyWishlistStockState(slide, item);
        }
        
        newSlides.push(slide);
      });
  
      if (newSlides.length) {
        wmDedupeRenderedProductSlides(pinnedHandle);
        const connectedSlides = newSlides.filter(slide => slide.isConnected);

        initializeSwiperForSlides(connectedSlides);
        connectedSlides.forEach(slide => initializeAudioControlsForProduct(slide));
  
        wmInitTitleMarquees(container);
        wmObserveNewMarqueeCards(connectedSlides);
  
        wmSafariLazyImageFix(container);
        wmMaybeInsertSpecialCards(container);
  
        connectedSlides.forEach(slide => {
          if (WM_PRODUCT_IO) WM_PRODUCT_IO.observe(slide);
        });
  
        wmHydrateSlidesNearViewport(container);
        wmEnsureFilterPills(container);
      }
  
      if (window.WM_INDEX_CURSOR >= source.length && endMessage) {
        endMessage.style.display = 'block';
      }
    } catch (e) {
      console.error('wmLoadNextIndexBatch failed', e);
    } finally {
      isLoading = false;
      if (loadingIndicator) loadingIndicator.style.display = 'none';
    }
  }
  
  function wmApplyWishlistStockState(slide, item){
    if (!slide) return;
  
    const hasItemAvailability = Object.prototype.hasOwnProperty.call(item || {}, 'available');
    const slideAvailability = slide.getAttribute('data-wm-available');
    const isAvailable = hasItemAvailability
      ? !!item.available
      : !(slideAvailability === '0' || slideAvailability === 'false');
    const isPinned = slide.getAttribute('data-wm-pinned') === '1';
    const isPreorder = !isPinned && (wmIsPreorderIndexItem(item) || slide.getAttribute('data-wm-preorder') === '1');
  
    if (isAvailable || isPreorder) return;
  
    const form = slide.querySelector('.ajax-cart-form');
    const btn = form ? form.querySelector('.add-to-cart') : null;
    if (!btn) return;
  
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('type', 'button');
    btn.classList.add('wm-sold-out-btn');
  
    const cartText = btn.querySelector('.cart-text');
    const loadingText = btn.querySelector('.cart-loading');
  
    if (cartText) cartText.textContent = 'SOLD OUT';
    if (cartText) cartText.style.display = 'inline';
    if (loadingText) loadingText.style.display = 'none';

    if (window.WM_FEED_SOURCE !== 'wishlist') {
      const notifyButton = slide.querySelector('.view-product-button');
      if (notifyButton) {
        if (!notifyButton.dataset.wmOriginalHref) {
          notifyButton.dataset.wmOriginalHref = notifyButton.getAttribute('href') || '';
        }
        notifyButton.textContent = 'NOTIFY ME';
        notifyButton.setAttribute('role', 'button');
        notifyButton.setAttribute('aria-label', 'Add to wishlist to be notified when back in stock');
        notifyButton.classList.add('wm-notify-me-button');
        wmScheduleSwishRefresh();
      }
    }
  }

  function wmApplyPinnedStockState(slide, item){
    if (!slide) return;

    slide.setAttribute('data-wm-pinned', '1');

    const pinnedItem = item || {};
    const hasAvailability = Object.prototype.hasOwnProperty.call(pinnedItem, 'available');

    if (!hasAvailability || pinnedItem.available !== false) {
      wmApplyWishlistStockState(slide, pinnedItem);
      return;
    }

    slide.setAttribute('data-wm-available', '0');
    slide.setAttribute('data-wm-preorder', '0');
    wmApplyWishlistStockState(slide, pinnedItem);

    requestAnimationFrame(() => wmApplyWishlistStockState(slide, pinnedItem));
    setTimeout(() => wmApplyWishlistStockState(slide, pinnedItem), 150);
    setTimeout(() => wmApplyWishlistStockState(slide, pinnedItem), 600);
  }

  async function wmHandleNotifyMeClick(notifyButton){
    if (!notifyButton || notifyButton.classList.contains('wm-notify-me-button--busy')) return;

    const slide = notifyButton.closest('.product-slide');
    notifyButton.classList.add('wm-notify-me-button--busy');
    notifyButton.setAttribute('aria-busy', 'true');

    if (!wmCustomerIsLoggedIn()) {
      wmSavePendingWishlistAdd(notifyButton);
      wmPromptWishlistLoginIfNeeded({
        title: 'Notify me when back in stock',
        body: 'Sign in or create an account to receive back in stock email notifications.'
      });
      notifyButton.classList.remove('wm-notify-me-button--busy');
      notifyButton.removeAttribute('aria-busy');
      return;
    }

    const wishlistButton = slide ? await wmWaitForWishlistButton(slide) : null;
    if (!slide || !wishlistButton) {
      console.warn('WM notify me could not find Swish wishlist button');
      notifyButton.classList.remove('wm-notify-me-button--busy');
      notifyButton.removeAttribute('aria-busy');
      return;
    }

    const wasActive = wmWishlistButtonIsActive(wishlistButton);

    if (!wasActive) {
      wishlistButton.click();
      wmIncrementWishlistCounterOptimistically();
    }

    notifyButton.textContent = 'SAVED';
    notifyButton.classList.add('wm-notify-me-button--saved');
    notifyButton.setAttribute('aria-label', 'Added to wishlist for back in stock notification');

    setTimeout(() => {
      wmRefreshWishlistCounter().catch(() => {});
      notifyButton.classList.remove('wm-notify-me-button--busy');
      notifyButton.removeAttribute('aria-busy');
    }, 700);
  }

  function wmWaitForWishlistButton(slide, maxWaitMs = 1600){
    if (!slide) return Promise.resolve(null);

    const existing = slide.querySelector('.wk-button');
    if (existing) return Promise.resolve(existing);

    wmScheduleSwishRefresh();

    const startedAt = Date.now();
    return new Promise(resolve => {
      (function check(){
        const btn = slide.querySelector('.wk-button');
        if (btn) {
          resolve(btn);
          return;
        }

        if (Date.now() - startedAt >= maxWaitMs) {
          resolve(null);
          return;
        }

        setTimeout(check, 100);
      })();
    });
  }

  function wmScheduleSwishRefresh(){
    clearTimeout(window.__wmSwishRefreshTimer);
    window.__wmSwishRefreshTimer = setTimeout(() => {
      [
        () => window.WishlistKing?.init?.(),
        () => window.WishlistKing?.render?.(),
        () => window.WishlistKing?.refresh?.(),
        () => window.WishlistKing?.reload?.(),
        () => window.WishlistKing?.scan?.(),
        () => window.WishlistKing?.buttons?.init?.(),
        () => window.WishlistKing?.buttons?.render?.(),
        () => window.WishlistKing?.buttons?.refresh?.()
      ].forEach(run => {
        try {
          const result = run();
          if (result && typeof result.catch === 'function') result.catch(() => {});
        } catch (e) {}
      });
    }, 100);
  }

  function wmWishlistButtonIsActive(button){
    if (!button) return false;

    const stateText = [
      button.getAttribute('aria-label'),
      button.getAttribute('title'),
      button.textContent
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    const classList = Array.from(button.classList || []).map(name => name.toLowerCase());

    return (
      button.getAttribute('aria-pressed') === 'true' ||
      stateText.includes('remove') ||
      stateText.includes('added') ||
      stateText.includes('selected') ||
      stateText.includes('in wishlist') ||
      classList.some(name => (
        name === 'active' ||
        name === 'is-active' ||
        name === 'selected' ||
        name === 'is-selected' ||
        name === 'wk-active' ||
        name === 'wk-selected' ||
        name === 'wk-added'
      ))
    );
  }

  function wmIncrementWishlistCounterOptimistically(){
    const current = wmReadWishlistCounter();
    wmSetWishlistCounter(current + 1);
  }

  function wmReadWishlistCounter(){
    const counter = document.querySelector('.wk-counter');
    const count = Number.parseInt((counter && counter.textContent) || '0', 10);
    return Number.isFinite(count) ? count : 0;
  }

  function wmSetWishlistCounter(count){
    document.querySelectorAll('.wk-counter').forEach(counter => {
      counter.textContent = String(count);
      counter.style.display = count > 0 ? '' : counter.style.display;
    });
  }

  async function wmRefreshWishlistCounter(){
    if (!(window.WishlistKing && window.WishlistKing._apis && window.WishlistKing._apis.wishlist)) return;

    const result = await window.WishlistKing._apis.wishlist.loadWishlist({ wishlistId: 'mine' });
    const rawItems =
      result?.wishlist?.items ||
      result?.items ||
      result?.products ||
      [];

    wmSetWishlistCounter(rawItems.length);
  }

  function wmScheduleWishlistCounterRefresh(){
    clearTimeout(window.__wmWishlistCounterRefreshTimer);
    window.__wmWishlistCounterRefreshTimer = setTimeout(() => {
      wmRefreshWishlistCounter().catch(() => {});
    }, 700);
  }

  function wmSavePendingWishlistAdd(trigger){
    const slide = trigger?.closest?.('.product-slide') || null;
    const handle = slide?.getAttribute('data-product-handle') || '';
    if (!handle) return;

    try {
      sessionStorage.setItem('wm_pending_wishlist_add', JSON.stringify({
        productHandle: handle,
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function wmClearPendingWishlistAdd(){
    try {
      sessionStorage.removeItem('wm_pending_wishlist_add');
    } catch (e) {}
  }

  function wmGetPendingWishlistAdd(){
    try {
      const pending = JSON.parse(sessionStorage.getItem('wm_pending_wishlist_add') || 'null');
      if (!pending?.productHandle) return null;
      if (pending.ts && Date.now() - pending.ts > 30 * 60 * 1000) {
        wmClearPendingWishlistAdd();
        return null;
      }
      return pending;
    } catch (e) {
      wmClearPendingWishlistAdd();
      return null;
    }
  }

  async function wmCompletePendingWishlistAdd(){
    if (!wmCustomerIsLoggedIn()) return;

    const pending = wmGetPendingWishlistAdd();
    if (!pending?.productHandle || !container) return;

    let slide = container.querySelector(
      `.product-slide[data-product-handle="${CSS.escape(pending.productHandle)}"]`
    );

    if (!slide) {
      const source = wmGetCurrentIndexSource();
      const targetIndex = source.findIndex((item) => (
        item?.handle || item?.product_handle
      ) === pending.productHandle);

      while (!slide && targetIndex >= 0 && window.WM_INDEX_CURSOR <= targetIndex) {
        const beforeCursor = window.WM_INDEX_CURSOR;
        await loadNextPage();
        slide = container.querySelector(
          `.product-slide[data-product-handle="${CSS.escape(pending.productHandle)}"]`
        );
        if (window.WM_INDEX_CURSOR === beforeCursor) break;
      }
    }

    const wishlistButton = slide ? await wmWaitForWishlistButton(slide, 3000) : null;
    if (!wishlistButton) return;

    if (!wmWishlistButtonIsActive(wishlistButton)) {
      wishlistButton.click();
      wmIncrementWishlistCounterOptimistically();
    }

    wmClearPendingWishlistAdd();
    setTimeout(() => {
      wmRefreshWishlistCounter().catch(() => {});
    }, 700);
  }

  function wmPromptWishlistLoginIfNeeded(options = {}){
    if (wmCustomerIsLoggedIn()) return;
    wmShowWishlistLoginModal(options);
  }

  function wmCustomerIsLoggedIn(){
    return window.WM_CUSTOMER_LOGGED_IN === true;
  }

  function wmShowWishlistLoginModal(options = {}){
    const title = options.title || 'Save your wishlist';
    const body = options.body || 'Sign in or create an account to save your wishlist and access it whenever you come back.';
    let modal = document.getElementById('wmWishlistLoginModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'wmWishlistLoginModal';
      modal.className = 'wm-wishlist-login-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'wmWishlistLoginTitle');
      modal.innerHTML = `
        <div class="wm-wishlist-login-modal__panel">
          <h2 id="wmWishlistLoginTitle">Saved to wishlist</h2>
          <p>Sign in or create an account to receive back in stock email notifications.</p>
          <div class="wm-wishlist-login-modal__actions">
            <button type="button" class="wm-wishlist-login-modal__button wm-wishlist-login-modal__button--primary" data-wm-login-action="login">Log in</button>
            <button type="button" class="wm-wishlist-login-modal__button wm-wishlist-login-modal__button--secondary" data-wm-login-action="signup">Sign up</button>
            <button type="button" class="wm-wishlist-login-modal__button wm-wishlist-login-modal__button--ghost" data-wm-login-action="close">Dismiss</button>
          </div>
        </div>
      `;
      document.body.appendChild(modal);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          wmClearPendingWishlistAdd();
          wmHideWishlistLoginModal();
          return;
        }

        const action = event.target.closest('[data-wm-login-action]')?.dataset?.wmLoginAction;
        if (!action) return;

        if (action === 'close') {
          wmClearPendingWishlistAdd();
          wmHideWishlistLoginModal();
          return;
        }

        wmSaveFeedReturnState();
        sessionStorage.setItem('wm_auth_return_pending', '1');

        const returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set('wm_return', '1');
        const returnTo = encodeURIComponent(returnUrl.pathname + returnUrl.search);

        window.location.href = '/customer_authentication/login?return_to=' + returnTo;
      });
    }

    const titleEl = modal.querySelector('#wmWishlistLoginTitle');
    const bodyEl = modal.querySelector('.wm-wishlist-login-modal__panel p');
    if (titleEl) titleEl.textContent = title;
    if (bodyEl) bodyEl.textContent = body;

    modal.hidden = false;
    modal.classList.add('is-visible');
  }

  function wmHideWishlistLoginModal(){
    const modal = document.getElementById('wmWishlistLoginModal');
    if (!modal) return;
    modal.classList.remove('is-visible');
    modal.hidden = true;
  }
  
  // WM: allow external pages (e.g. wishlist feed) to initialise injected ajax-card slides
  window.wmInitInjectedSlides = function(root){
    if (!root) return;
  
    const slides = Array.from(root.querySelectorAll('.product-slide'));
    if (!slides.length) return;
  
    initializeSwiperForSlides(slides);
    slides.forEach(slide => initializeAudioControlsForProduct(slide));
  
    wmInitTitleMarquees(root);
    wmObserveNewMarqueeCards(slides);
  
    wmSafariLazyImageFix(root);
  
    slides.forEach(slide => {
      if (window.WM_PRODUCT_IO) WM_PRODUCT_IO.observe(slide);
    });
  
    if (typeof wmHydrateSlidesNearViewport === 'function') {
      wmHydrateSlidesNearViewport(root);
    }

    slides.forEach(slide => wmApplyWishlistStockState(slide));
  };
  
  async function loadNextPage(){
    return wmLoadNextIndexBatch();
  }
    
    (function(){
    const btn = document.querySelector('.wm-feed-menu-btn');
    const menu = document.getElementById('wmFeedMenu');
    const backdrop = document.getElementById('wmFeedMenuBackdrop');
    const closeBtn = document.getElementById('wmFeedMenuClose');
  
    const wmTogglePreorders = document.getElementById('wmTogglePreorders');
  
    const gridUrlEl = document.getElementById('wmGridUrl');
    const viewRadios = menu ? menu.querySelectorAll('input[name="wm_view"]') : [];
    const wmGridViewAction = document.getElementById('wmGridViewAction');
    const wmGridUrl = document.getElementById('wmGridUrl');
  
    const hasMenuUi = !!(btn && menu && backdrop);
  
    const WM_PREORDER_STORAGE_KEY = 'wm_show_preorders';
    let WM_SHOW_PREORDERS = true;
  
    function wmGetSavedPreorderSetting(){
      try {
        const saved = localStorage.getItem(WM_PREORDER_STORAGE_KEY);
        if (saved === '0') return false;
        if (saved === '1') return true;
      } catch (e) {}
      return true;
    }
  
    function wmSavePreorderSetting(value){
      try {
        localStorage.setItem(WM_PREORDER_STORAGE_KEY, value ? '1' : '0');
      } catch (e) {}
    }
  
    
  
    function wmGetActiveSort(){
      try {
        const params = new URLSearchParams(window.location.search);
        return params.get('sort_by') || container?.dataset?.sortBy || 'created-descending';
      } catch (e) {
        return container?.dataset?.sortBy || 'created-descending';
      }
    }

    function wmParseIndexDate(value){
      if (!value) return 0;

      if (typeof value === 'string' || value instanceof String) {
        const parsed = new Date(value).getTime();
        return Number.isFinite(parsed) ? parsed : 0;
      }

      if (Array.isArray(value) && value.length >= 6) {
        const seconds = Number(value[0]) || 0;
        const minutes = Number(value[1]) || 0;
        const hours = Number(value[2]) || 0;
        const day = Number(value[3]) || 1;
        const month = (Number(value[4]) || 1) - 1;
        const year = Number(value[5]) || 1970;

        return Date.UTC(year, month, day, hours, minutes, seconds);
      }

      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
      }

      return 0;
    }

    function wmBuildActiveCollectionIndex(){
      const full = Array.isArray(window.WM_COLLECTION_INDEX) ? window.WM_COLLECTION_INDEX : [];
      const filtered = WM_SHOW_PREORDERS ? full.slice() : full.filter(item => !wmIsPreorderIndexItem(item));
      const activeSort = wmGetActiveSort();

      if (activeSort === 'created-descending') {
        filtered.sort((a, b) => {
          const timeA = wmParseIndexDate(a?.stock_movement_at || a?.created_at || null);
          const timeB = wmParseIndexDate(b?.stock_movement_at || b?.created_at || null);

          return timeB - timeA;
        });

      }

      const pinnedHandle = wmShouldPrioritizePinnedHandle() ? wmGetPinnedHandleFromUrl() : '';

      if (pinnedHandle) {
        const pinnedIndex = filtered.findIndex(item => (item?.handle || item?.product_handle) === pinnedHandle);

        if (pinnedIndex > 0) {
          const [pinnedItem] = filtered.splice(pinnedIndex, 1);
          filtered.unshift(pinnedItem);
        } else if (pinnedIndex === -1 && window.WM_FEED_SOURCE !== 'wishlist') {
          filtered.unshift(wmPinnedFallbackItem(pinnedHandle));
        }
      }

      if (!wmIsShuffleMode()) return filtered;

      for (let i = filtered.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [filtered[i], filtered[j]] = [filtered[j], filtered[i]];
      }

      if (pinnedHandle) {
        const pinnedIndex = filtered.findIndex(item => (item?.handle || item?.product_handle) === pinnedHandle);

        if (pinnedIndex > 0) {
          const [pinnedItem] = filtered.splice(pinnedIndex, 1);
          filtered.unshift(pinnedItem);
        }
      }

      return filtered;
    }

    function wmCaptureFeedAnchor(){
      if (!container) return null;

      const anchorSlide = mostVisibleProductSlide();
      const source = wmGetCurrentIndexSource();
      const handle = anchorSlide?.dataset?.productHandle || null;
      const anchorIndex = handle
        ? source.findIndex(item => (item?.handle || item?.product_handle) === handle)
        : -1;

      return {
        handle,
        anchorIndex,
        offsetInSlide: anchorSlide ? (container.scrollTop - anchorSlide.offsetTop) : 0
      };
    }

    async function wmRestoreFeedAnchor(anchor){
      if (!anchor || !container) return;

      const source = wmGetCurrentIndexSource();
      if (!source.length) {
        container.scrollTop = 0;
        return;
      }

      let targetHandle = anchor.handle;
      const stillExists = targetHandle && source.some(item => (item?.handle || item?.product_handle) === targetHandle);

      if (!stillExists) {
        const fallbackIndex = Math.max(0, Math.min(anchor.anchorIndex, source.length - 1));
        const fallbackItem = source[fallbackIndex];
        targetHandle = fallbackItem && (fallbackItem.handle || fallbackItem.product_handle);
      }

      if (!targetHandle) {
        container.scrollTop = 0;
        return;
      }

      let target = container.querySelector(`.product-slide[data-product-handle="${CSS.escape(targetHandle)}"]`);

      while (!target && window.WM_INDEX_CURSOR < source.length) {
        await loadNextPage();
        target = container.querySelector(`.product-slide[data-product-handle="${CSS.escape(targetHandle)}"]`);
      }

      const top = target ? (target.offsetTop + (anchor.offsetInSlide || 0)) : 0;

      requestAnimationFrame(() => {
        container.scrollTop = top;
        setTimeout(() => { container.scrollTop = top; }, 60);
        setTimeout(() => { container.scrollTop = top; }, 180);
      });
    }
  
    async function wmRebuildFeedFromIndex(options = {}){
      const preserveAnchor = options.preserveAnchor !== false;
      const resetToTop = options.resetToTop !== false;
      await wmWaitForCollectionIndex();

      const anchor = preserveAnchor ? wmCaptureFeedAnchor() : null;
  
      window.WM_ACTIVE_COLLECTION_INDEX = wmBuildActiveCollectionIndex();
      window.WM_INDEX_CURSOR = 0;
  
      try {
        if (WM_PLAYER) {
          WM_PLAYER.pause();
          WM_PLAYER.currentTime = 0;
        }
      } catch (e) {}
  
      container.querySelectorAll('.product-slide').forEach(el => el.remove());
  
      if (typeof WM_SPECIAL !== 'undefined') {
        WM_SPECIAL.inserted = new Set();
        WM_SPECIAL.productCount = 0;
      }

      if (endMessage) endMessage.style.display = 'none';
      await loadNextPage();
      wmDedupeRenderedProductSlides(wmGetPinnedHandleFromUrl());
      wmEnsureFilterPills(container);
      if (preserveAnchor) {
        await wmRestoreFeedAnchor(anchor);
      } else if (resetToTop) {
        requestAnimationFrame(() => {
          container.scrollTop = 0;
          setTimeout(() => { container.scrollTop = 0; }, 60);
          setTimeout(() => { container.scrollTop = 0; }, 180);
        });
      }
      document.documentElement.classList.remove('wm-prepinned');
    }
  
    async function wmSetPreorderVisibility(showPreorders){
      WM_SHOW_PREORDERS = !!showPreorders;
      wmSavePreorderSetting(WM_SHOW_PREORDERS);
      await wmRebuildFeedFromIndex();
    }
  
    function openMenu(){
      if (!hasMenuUi) return;
      menu.hidden = false;
      backdrop.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
  
    function closeMenu(){
      if (!hasMenuUi) return;
      menu.hidden = true;
      backdrop.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
  
    function currentIsGrid(){
      try {
        const u = new URL(window.location.href);
        return u.searchParams.get('view') === 'grid';
      } catch(e){
        return false;
      }
    }
  
    window.WM_ACTIVE_COLLECTION_INDEX = Array.isArray(window.WM_COLLECTION_INDEX) ? window.WM_COLLECTION_INDEX : [];
  
    WM_SHOW_PREORDERS = wmGetSavedPreorderSetting();
    window.WM_ACTIVE_COLLECTION_INDEX = wmBuildActiveCollectionIndex();
  
    if (wmTogglePreorders) {
      wmTogglePreorders.checked = WM_SHOW_PREORDERS;
      wmTogglePreorders.addEventListener('change', async function () {
        await wmSetPreorderVisibility(!!wmTogglePreorders.checked);
      });
    }
  
    (async function(){
      await wmWaitForCollectionIndex();
      window.WM_ACTIVE_COLLECTION_INDEX = wmBuildActiveCollectionIndex();
  
      const isWishlistFeed = window.WM_FEED_SOURCE === 'wishlist';
      const needsNewestRebuild = wmGetActiveSort() === 'created-descending';
      const hasPendingReturn = !!WM_PENDING_RETURN || WM_RETURN_RESTORE_ACTIVE;
      const hasPinnedLink = wmShouldPrioritizePinnedHandle();
  
      if (hasPendingReturn) {
        return;
      }

      if (window.WM_FEED_SOURCE !== 'recommendations' && hasPinnedLink) {
        await wmRebuildFeedFromIndex({ preserveAnchor: false, resetToTop: true });
      } else if (isWishlistFeed || !WM_SHOW_PREORDERS) {
        await wmRebuildFeedFromIndex();
      } else if (needsNewestRebuild) {
        await wmRebuildFeedFromIndex({ preserveAnchor: false, resetToTop: false });
      }
    })();
  
    if (hasMenuUi && wmGridViewAction && wmGridUrl) {
      wmGridViewAction.addEventListener('click', function () {
        window.location.href = wmGridUrl.href;
      });
    }
  
    if (hasMenuUi) {
      btn.addEventListener('click', openMenu);
      backdrop.addEventListener('click', closeMenu);
      if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  
      const isGrid = currentIsGrid();
      viewRadios.forEach((r) => {
        r.checked = (r.value === (isGrid ? 'grid' : 'scroll'));
      });
  
      viewRadios.forEach((radio) => {
        radio.addEventListener('change', function(){
          if (!radio.checked) return;
  
          try {
            const u = new URL(window.location.href);
  
            if (radio.value === 'grid') {
              window.location.href = gridUrlEl ? gridUrlEl.href : (u.pathname + '?view=grid');
            } else {
              u.searchParams.delete('view');
              window.location.href = u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
            }
          } catch(e){}
  
          closeMenu();
        });
      });
    }
  })();
    
  
  
    });
